
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gmwAy", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $be97facf33688a34$var$isNil(value) {
    return value == null;
}
module.exports = $be97facf33688a34$var$isNil;

});

parcelRegister("4aLrJ", function(module, exports) {

var $biJva = parcelRequire("biJva");

var $7Neex = parcelRequire("7Neex");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $309ce66ec4c5176a$var$pick = $7Neex(function(object, paths) {
    return object == null ? {} : $biJva(object, paths);
});
module.exports = $309ce66ec4c5176a$var$pick;

});
parcelRegister("biJva", function(module, exports) {

var $3YkJA = parcelRequire("3YkJA");

var $avZA1 = parcelRequire("avZA1");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $83a4abd976ba0982$var$basePick(object, paths) {
    return $3YkJA(object, paths, function(value, path) {
        return $avZA1(object, path);
    });
}
module.exports = $83a4abd976ba0982$var$basePick;

});

parcelRegister("7Neex", function(module, exports) {

var $apbnB = parcelRequire("apbnB");

var $b1odC = parcelRequire("b1odC");

var $aOJst = parcelRequire("aOJst");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $5ac8267f4818bc5c$var$flatRest(func) {
    return $aOJst($b1odC(func, undefined, $apbnB), func + '');
}
module.exports = $5ac8267f4818bc5c$var$flatRest;

});


parcelRegister("3Eyn9", function(module, exports) {

var $eJtyL = parcelRequire("eJtyL");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $2a8fc52f1cf6ee5f$var$set(object, path, value) {
    return object == null ? object : $eJtyL(object, path, value);
}
module.exports = $2a8fc52f1cf6ee5f$var$set;

});

parcelRegister("1i5fs", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f0b8b113d6ace0a$export$2e2bcd8739ae039);

var $jcViS = parcelRequire("jcViS");

var $fMi8z = parcelRequire("fMi8z");

var $42LHj = parcelRequire("42LHj");

var $gbJR4 = parcelRequire("gbJR4");

var $cb0Dj = parcelRequire("cb0Dj");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $0f0b8b113d6ace0a$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $jcViS.default),
    formatLong: (0, $fMi8z.default),
    formatRelative: (0, $42LHj.default),
    localize: (0, $gbJR4.default),
    match: (0, $cb0Dj.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0f0b8b113d6ace0a$export$2e2bcd8739ae039 = $0f0b8b113d6ace0a$var$locale;

});
parcelRegister("jcViS", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfbb96968511a57b$export$2e2bcd8739ae039);
var $dfbb96968511a57b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $dfbb96968511a57b$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $dfbb96968511a57b$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $dfbb96968511a57b$export$2e2bcd8739ae039 = $dfbb96968511a57b$var$formatDistance;

});

parcelRegister("fMi8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7c968644bbe3ad0$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $b7c968644bbe3ad0$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b7c968644bbe3ad0$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b7c968644bbe3ad0$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b7c968644bbe3ad0$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $b7c968644bbe3ad0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $b7c968644bbe3ad0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $b7c968644bbe3ad0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b7c968644bbe3ad0$export$2e2bcd8739ae039 = $b7c968644bbe3ad0$var$formatLong;

});

parcelRegister("42LHj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f1c590f28a4761f$export$2e2bcd8739ae039);
var $2f1c590f28a4761f$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $2f1c590f28a4761f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2f1c590f28a4761f$var$formatRelativeLocale[token];
};
var $2f1c590f28a4761f$export$2e2bcd8739ae039 = $2f1c590f28a4761f$var$formatRelative;

});

parcelRegister("gbJR4", function(module, exports) {
$parcel$export(module.exports, "default", () => $030a99c738e8229b$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $030a99c738e8229b$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $030a99c738e8229b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $030a99c738e8229b$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $030a99c738e8229b$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $030a99c738e8229b$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $030a99c738e8229b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $030a99c738e8229b$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $030a99c738e8229b$var$localize = {
    ordinalNumber: $030a99c738e8229b$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $030a99c738e8229b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $030a99c738e8229b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $030a99c738e8229b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $030a99c738e8229b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $030a99c738e8229b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $030a99c738e8229b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $030a99c738e8229b$export$2e2bcd8739ae039 = $030a99c738e8229b$var$localize;

});

parcelRegister("cb0Dj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dd700d59a4d6395$export$2e2bcd8739ae039);

var $lXxnR = parcelRequire("lXxnR");

var $9R4Zi = parcelRequire("9R4Zi");
var $8dd700d59a4d6395$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $8dd700d59a4d6395$var$parseOrdinalNumberPattern = /\d+/i;
var $8dd700d59a4d6395$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $8dd700d59a4d6395$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $8dd700d59a4d6395$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $8dd700d59a4d6395$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8dd700d59a4d6395$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $8dd700d59a4d6395$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $8dd700d59a4d6395$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $8dd700d59a4d6395$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $8dd700d59a4d6395$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $8dd700d59a4d6395$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $8dd700d59a4d6395$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $8dd700d59a4d6395$var$matchOrdinalNumberPattern,
        parsePattern: $8dd700d59a4d6395$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $8dd700d59a4d6395$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8dd700d59a4d6395$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $8dd700d59a4d6395$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8dd700d59a4d6395$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $8dd700d59a4d6395$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8dd700d59a4d6395$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $8dd700d59a4d6395$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8dd700d59a4d6395$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $8dd700d59a4d6395$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8dd700d59a4d6395$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8dd700d59a4d6395$export$2e2bcd8739ae039 = $8dd700d59a4d6395$var$match;

});


parcelRegister("eCo9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa4759bbba421b71$export$2e2bcd8739ae039);

var $gJJ6n = parcelRequire("gJJ6n");

var $jbAAg = parcelRequire("jbAAg");

var $9L6r4 = parcelRequire("9L6r4");

var $hjcEr = parcelRequire("hjcEr");

var $d3jZV = parcelRequire("d3jZV");
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $aa4759bbba421b71$var$locale = {
    code: 'cs',
    formatDistance: (0, $gJJ6n.default),
    formatLong: (0, $jbAAg.default),
    formatRelative: (0, $9L6r4.default),
    localize: (0, $hjcEr.default),
    match: (0, $d3jZV.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $aa4759bbba421b71$export$2e2bcd8739ae039 = $aa4759bbba421b71$var$locale;

});
parcelRegister("gJJ6n", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2f3d59c03f7b3d3$export$2e2bcd8739ae039);
var $c2f3d59c03f7b3d3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $c2f3d59c03f7b3d3$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $c2f3d59c03f7b3d3$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $c2f3d59c03f7b3d3$export$2e2bcd8739ae039 = $c2f3d59c03f7b3d3$var$formatDistance;

});

parcelRegister("jbAAg", function(module, exports) {
$parcel$export(module.exports, "default", () => $df7b6c3116804043$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $df7b6c3116804043$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $df7b6c3116804043$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $df7b6c3116804043$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $df7b6c3116804043$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $df7b6c3116804043$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $df7b6c3116804043$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $df7b6c3116804043$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $df7b6c3116804043$export$2e2bcd8739ae039 = $df7b6c3116804043$var$formatLong;

});

parcelRegister("9L6r4", function(module, exports) {
$parcel$export(module.exports, "default", () => $71ad7ed53415f22b$export$2e2bcd8739ae039);
var $71ad7ed53415f22b$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $71ad7ed53415f22b$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $71ad7ed53415f22b$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $71ad7ed53415f22b$var$formatRelative = function formatRelative(token, date) {
    var format = $71ad7ed53415f22b$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $71ad7ed53415f22b$export$2e2bcd8739ae039 = $71ad7ed53415f22b$var$formatRelative;

});

parcelRegister("hjcEr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c99e064cf0e27ee2$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $c99e064cf0e27ee2$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $c99e064cf0e27ee2$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $c99e064cf0e27ee2$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $c99e064cf0e27ee2$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $c99e064cf0e27ee2$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $c99e064cf0e27ee2$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $c99e064cf0e27ee2$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $c99e064cf0e27ee2$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $c99e064cf0e27ee2$var$localize = {
    ordinalNumber: $c99e064cf0e27ee2$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $c99e064cf0e27ee2$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $c99e064cf0e27ee2$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $c99e064cf0e27ee2$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $c99e064cf0e27ee2$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $c99e064cf0e27ee2$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $c99e064cf0e27ee2$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c99e064cf0e27ee2$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c99e064cf0e27ee2$export$2e2bcd8739ae039 = $c99e064cf0e27ee2$var$localize;

});

parcelRegister("d3jZV", function(module, exports) {
$parcel$export(module.exports, "default", () => $980b114feaebe97a$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $980b114feaebe97a$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $980b114feaebe97a$var$parseOrdinalNumberPattern = /\d+/i;
var $980b114feaebe97a$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $980b114feaebe97a$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $980b114feaebe97a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $980b114feaebe97a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $980b114feaebe97a$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $980b114feaebe97a$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $980b114feaebe97a$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $980b114feaebe97a$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $980b114feaebe97a$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $980b114feaebe97a$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $980b114feaebe97a$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $980b114feaebe97a$var$matchOrdinalNumberPattern,
        parsePattern: $980b114feaebe97a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $980b114feaebe97a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $980b114feaebe97a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $980b114feaebe97a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $980b114feaebe97a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $980b114feaebe97a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $980b114feaebe97a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $980b114feaebe97a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $980b114feaebe97a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $980b114feaebe97a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $980b114feaebe97a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $980b114feaebe97a$export$2e2bcd8739ae039 = $980b114feaebe97a$var$match;

});


parcelRegister("8TV2V", function(module, exports) {
$parcel$export(module.exports, "default", () => $67afb5f6b46c7f2f$export$2e2bcd8739ae039);

var $4u3eY = parcelRequire("4u3eY");

var $13juU = parcelRequire("13juU");

var $irwOS = parcelRequire("irwOS");

var $7AOui = parcelRequire("7AOui");

var $9ECFW = parcelRequire("9ECFW");
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $67afb5f6b46c7f2f$var$locale = {
    code: 'da',
    formatDistance: (0, $4u3eY.default),
    formatLong: (0, $13juU.default),
    formatRelative: (0, $irwOS.default),
    localize: (0, $7AOui.default),
    match: (0, $9ECFW.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $67afb5f6b46c7f2f$export$2e2bcd8739ae039 = $67afb5f6b46c7f2f$var$locale;

});
parcelRegister("4u3eY", function(module, exports) {
$parcel$export(module.exports, "default", () => $343c7a4128fd3b6f$export$2e2bcd8739ae039);
var $343c7a4128fd3b6f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $343c7a4128fd3b6f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $343c7a4128fd3b6f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $343c7a4128fd3b6f$export$2e2bcd8739ae039 = $343c7a4128fd3b6f$var$formatDistance;

});

parcelRegister("13juU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c45320cee36886a$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $0c45320cee36886a$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $0c45320cee36886a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $0c45320cee36886a$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $0c45320cee36886a$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $0c45320cee36886a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $0c45320cee36886a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $0c45320cee36886a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0c45320cee36886a$export$2e2bcd8739ae039 = $0c45320cee36886a$var$formatLong;

});

parcelRegister("irwOS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d434e568007edf$export$2e2bcd8739ae039);
var $d6d434e568007edf$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $d6d434e568007edf$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d6d434e568007edf$var$formatRelativeLocale[token];
};
var $d6d434e568007edf$export$2e2bcd8739ae039 = $d6d434e568007edf$var$formatRelative;

});

parcelRegister("7AOui", function(module, exports) {
$parcel$export(module.exports, "default", () => $58730f03a2486796$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $58730f03a2486796$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $58730f03a2486796$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $58730f03a2486796$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $58730f03a2486796$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $58730f03a2486796$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $58730f03a2486796$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $58730f03a2486796$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $58730f03a2486796$var$localize = {
    ordinalNumber: $58730f03a2486796$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $58730f03a2486796$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $58730f03a2486796$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $58730f03a2486796$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $58730f03a2486796$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $58730f03a2486796$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $58730f03a2486796$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $58730f03a2486796$export$2e2bcd8739ae039 = $58730f03a2486796$var$localize;

});

parcelRegister("9ECFW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7075d9a47e09eab2$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $7075d9a47e09eab2$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $7075d9a47e09eab2$var$parseOrdinalNumberPattern = /\d+/i;
var $7075d9a47e09eab2$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $7075d9a47e09eab2$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $7075d9a47e09eab2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $7075d9a47e09eab2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7075d9a47e09eab2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $7075d9a47e09eab2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7075d9a47e09eab2$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $7075d9a47e09eab2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $7075d9a47e09eab2$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $7075d9a47e09eab2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $7075d9a47e09eab2$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $7075d9a47e09eab2$var$matchOrdinalNumberPattern,
        parsePattern: $7075d9a47e09eab2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $7075d9a47e09eab2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7075d9a47e09eab2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $7075d9a47e09eab2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7075d9a47e09eab2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $7075d9a47e09eab2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7075d9a47e09eab2$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $7075d9a47e09eab2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7075d9a47e09eab2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $7075d9a47e09eab2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7075d9a47e09eab2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7075d9a47e09eab2$export$2e2bcd8739ae039 = $7075d9a47e09eab2$var$match;

});


parcelRegister("gEn7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1f2506de07a49a4$export$2e2bcd8739ae039);

var $lXDgk = parcelRequire("lXDgk");

var $j5q2m = parcelRequire("j5q2m");

var $aG0KG = parcelRequire("aG0KG");

var $9LR73 = parcelRequire("9LR73");

var $95iOf = parcelRequire("95iOf");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $c1f2506de07a49a4$var$locale = {
    code: 'de',
    formatDistance: (0, $lXDgk.default),
    formatLong: (0, $j5q2m.default),
    formatRelative: (0, $aG0KG.default),
    localize: (0, $9LR73.default),
    match: (0, $95iOf.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c1f2506de07a49a4$export$2e2bcd8739ae039 = $c1f2506de07a49a4$var$locale;

});
parcelRegister("lXDgk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffcd905331ac8379$export$2e2bcd8739ae039);
var $ffcd905331ac8379$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $ffcd905331ac8379$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $ffcd905331ac8379$var$formatDistanceLocale[token].withPreposition : $ffcd905331ac8379$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $ffcd905331ac8379$export$2e2bcd8739ae039 = $ffcd905331ac8379$var$formatDistance;

});

parcelRegister("j5q2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $de52ae5f6f501260$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $de52ae5f6f501260$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $de52ae5f6f501260$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $de52ae5f6f501260$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $de52ae5f6f501260$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $de52ae5f6f501260$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $de52ae5f6f501260$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $de52ae5f6f501260$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $de52ae5f6f501260$export$2e2bcd8739ae039 = $de52ae5f6f501260$var$formatLong;

});

parcelRegister("aG0KG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c5e68f7777c3052$export$2e2bcd8739ae039);
var $7c5e68f7777c3052$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $7c5e68f7777c3052$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7c5e68f7777c3052$var$formatRelativeLocale[token];
};
var $7c5e68f7777c3052$export$2e2bcd8739ae039 = $7c5e68f7777c3052$var$formatRelative;

});

parcelRegister("9LR73", function(module, exports) {
$parcel$export(module.exports, "default", () => $71d1b3e919bd68dc$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $71d1b3e919bd68dc$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $71d1b3e919bd68dc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $71d1b3e919bd68dc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $71d1b3e919bd68dc$var$formattingMonthValues = {
    narrow: $71d1b3e919bd68dc$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $71d1b3e919bd68dc$var$monthValues.wide
};
var $71d1b3e919bd68dc$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $71d1b3e919bd68dc$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $71d1b3e919bd68dc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $71d1b3e919bd68dc$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $71d1b3e919bd68dc$var$localize = {
    ordinalNumber: $71d1b3e919bd68dc$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $71d1b3e919bd68dc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $71d1b3e919bd68dc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $71d1b3e919bd68dc$var$monthValues,
        formattingValues: $71d1b3e919bd68dc$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $71d1b3e919bd68dc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $71d1b3e919bd68dc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $71d1b3e919bd68dc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $71d1b3e919bd68dc$export$2e2bcd8739ae039 = $71d1b3e919bd68dc$var$localize;

});

parcelRegister("95iOf", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d32bdb2c0e5101$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $69d32bdb2c0e5101$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $69d32bdb2c0e5101$var$parseOrdinalNumberPattern = /\d+/i;
var $69d32bdb2c0e5101$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $69d32bdb2c0e5101$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $69d32bdb2c0e5101$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $69d32bdb2c0e5101$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $69d32bdb2c0e5101$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $69d32bdb2c0e5101$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $69d32bdb2c0e5101$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $69d32bdb2c0e5101$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $69d32bdb2c0e5101$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $69d32bdb2c0e5101$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $69d32bdb2c0e5101$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $69d32bdb2c0e5101$var$matchOrdinalNumberPattern,
        parsePattern: $69d32bdb2c0e5101$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $69d32bdb2c0e5101$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $69d32bdb2c0e5101$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $69d32bdb2c0e5101$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $69d32bdb2c0e5101$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $69d32bdb2c0e5101$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $69d32bdb2c0e5101$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $69d32bdb2c0e5101$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $69d32bdb2c0e5101$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $69d32bdb2c0e5101$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $69d32bdb2c0e5101$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $69d32bdb2c0e5101$export$2e2bcd8739ae039 = $69d32bdb2c0e5101$var$match;

});


parcelRegister("giyFP", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdd9394113160b4a$export$2e2bcd8739ae039);

var $jWy2t = parcelRequire("jWy2t");

var $il5dP = parcelRequire("il5dP");

var $fkRfS = parcelRequire("fkRfS");

var $iGvbf = parcelRequire("iGvbf");

var $kH1Yh = parcelRequire("kH1Yh");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $bdd9394113160b4a$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $jWy2t.default),
    formatLong: (0, $il5dP.default),
    formatRelative: (0, $fkRfS.default),
    localize: (0, $iGvbf.default),
    match: (0, $kH1Yh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $bdd9394113160b4a$export$2e2bcd8739ae039 = $bdd9394113160b4a$var$locale;

});
parcelRegister("il5dP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d59e3d2696542879$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $d59e3d2696542879$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d59e3d2696542879$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d59e3d2696542879$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d59e3d2696542879$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $d59e3d2696542879$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $d59e3d2696542879$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $d59e3d2696542879$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d59e3d2696542879$export$2e2bcd8739ae039 = $d59e3d2696542879$var$formatLong;

});


parcelRegister("gym9X", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0d102c08d4bfae5$export$2e2bcd8739ae039);

var $jWy2t = parcelRequire("jWy2t");

var $fkRfS = parcelRequire("fkRfS");

var $iGvbf = parcelRequire("iGvbf");

var $kH1Yh = parcelRequire("kH1Yh");

var $kWtp9 = parcelRequire("kWtp9");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $c0d102c08d4bfae5$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $jWy2t.default),
    formatLong: (0, $kWtp9.default),
    formatRelative: (0, $fkRfS.default),
    localize: (0, $iGvbf.default),
    match: (0, $kH1Yh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c0d102c08d4bfae5$export$2e2bcd8739ae039 = $c0d102c08d4bfae5$var$locale;

});
parcelRegister("kWtp9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3f00893d6ad56c9$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $f3f00893d6ad56c9$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $f3f00893d6ad56c9$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f3f00893d6ad56c9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f3f00893d6ad56c9$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $f3f00893d6ad56c9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $f3f00893d6ad56c9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $f3f00893d6ad56c9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f3f00893d6ad56c9$export$2e2bcd8739ae039 = $f3f00893d6ad56c9$var$formatLong;

});


parcelRegister("iUIde", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc4fc09e5c56860e$export$2e2bcd8739ae039);

var $kL5G1 = parcelRequire("kL5G1");

var $awgaZ = parcelRequire("awgaZ");

var $9zXSD = parcelRequire("9zXSD");

var $bcMIz = parcelRequire("bcMIz");

var $hmJt4 = parcelRequire("hmJt4");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $dc4fc09e5c56860e$var$locale = {
    code: 'es',
    formatDistance: (0, $kL5G1.default),
    formatLong: (0, $awgaZ.default),
    formatRelative: (0, $9zXSD.default),
    localize: (0, $bcMIz.default),
    match: (0, $hmJt4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $dc4fc09e5c56860e$export$2e2bcd8739ae039 = $dc4fc09e5c56860e$var$locale;

});
parcelRegister("kL5G1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1cc99b98bfdbf57$export$2e2bcd8739ae039);
var $f1cc99b98bfdbf57$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $f1cc99b98bfdbf57$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f1cc99b98bfdbf57$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $f1cc99b98bfdbf57$export$2e2bcd8739ae039 = $f1cc99b98bfdbf57$var$formatDistance;

});

parcelRegister("awgaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a8970c8c8bb5f9b$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $7a8970c8c8bb5f9b$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $7a8970c8c8bb5f9b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7a8970c8c8bb5f9b$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7a8970c8c8bb5f9b$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $7a8970c8c8bb5f9b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $7a8970c8c8bb5f9b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $7a8970c8c8bb5f9b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7a8970c8c8bb5f9b$export$2e2bcd8739ae039 = $7a8970c8c8bb5f9b$var$formatLong;

});

parcelRegister("9zXSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f95d4e2c1783b8d$export$2e2bcd8739ae039);
var $6f95d4e2c1783b8d$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $6f95d4e2c1783b8d$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $6f95d4e2c1783b8d$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $6f95d4e2c1783b8d$var$formatRelativeLocalePlural[token];
    else return $6f95d4e2c1783b8d$var$formatRelativeLocale[token];
};
var $6f95d4e2c1783b8d$export$2e2bcd8739ae039 = $6f95d4e2c1783b8d$var$formatRelative;

});

parcelRegister("bcMIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $82869b0de70fa92a$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $82869b0de70fa92a$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $82869b0de70fa92a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $82869b0de70fa92a$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $82869b0de70fa92a$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $82869b0de70fa92a$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $82869b0de70fa92a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $82869b0de70fa92a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $82869b0de70fa92a$var$localize = {
    ordinalNumber: $82869b0de70fa92a$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $82869b0de70fa92a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $82869b0de70fa92a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $82869b0de70fa92a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $82869b0de70fa92a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $82869b0de70fa92a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $82869b0de70fa92a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $82869b0de70fa92a$export$2e2bcd8739ae039 = $82869b0de70fa92a$var$localize;

});

parcelRegister("hmJt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca47c2b8bd7af50e$export$2e2bcd8739ae039);

var $lXxnR = parcelRequire("lXxnR");

var $9R4Zi = parcelRequire("9R4Zi");
var $ca47c2b8bd7af50e$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $ca47c2b8bd7af50e$var$parseOrdinalNumberPattern = /\d+/i;
var $ca47c2b8bd7af50e$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $ca47c2b8bd7af50e$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $ca47c2b8bd7af50e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $ca47c2b8bd7af50e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ca47c2b8bd7af50e$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $ca47c2b8bd7af50e$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $ca47c2b8bd7af50e$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $ca47c2b8bd7af50e$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $ca47c2b8bd7af50e$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $ca47c2b8bd7af50e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $ca47c2b8bd7af50e$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $ca47c2b8bd7af50e$var$matchOrdinalNumberPattern,
        parsePattern: $ca47c2b8bd7af50e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $ca47c2b8bd7af50e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ca47c2b8bd7af50e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $ca47c2b8bd7af50e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ca47c2b8bd7af50e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $ca47c2b8bd7af50e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ca47c2b8bd7af50e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $ca47c2b8bd7af50e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ca47c2b8bd7af50e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $ca47c2b8bd7af50e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ca47c2b8bd7af50e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ca47c2b8bd7af50e$export$2e2bcd8739ae039 = $ca47c2b8bd7af50e$var$match;

});


parcelRegister("az5br", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b11319f2e940600$export$2e2bcd8739ae039);

var $98XTU = parcelRequire("98XTU");

var $iOtJB = parcelRequire("iOtJB");

var $4FbME = parcelRequire("4FbME");

var $lRRPG = parcelRequire("lRRPG");

var $hjR6o = parcelRequire("hjR6o");
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $7b11319f2e940600$var$locale = {
    code: 'et',
    formatDistance: (0, $98XTU.default),
    formatLong: (0, $iOtJB.default),
    formatRelative: (0, $4FbME.default),
    localize: (0, $lRRPG.default),
    match: (0, $hjR6o.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7b11319f2e940600$export$2e2bcd8739ae039 = $7b11319f2e940600$var$locale;

});
parcelRegister("98XTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a83537a4ba555b6$export$2e2bcd8739ae039);
var $6a83537a4ba555b6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $6a83537a4ba555b6$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $6a83537a4ba555b6$var$formatDistanceLocale[token].withPreposition : $6a83537a4ba555b6$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $6a83537a4ba555b6$export$2e2bcd8739ae039 = $6a83537a4ba555b6$var$formatDistance;

});

parcelRegister("iOtJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $db23f6290dac03fd$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $db23f6290dac03fd$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $db23f6290dac03fd$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $db23f6290dac03fd$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $db23f6290dac03fd$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $db23f6290dac03fd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $db23f6290dac03fd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $db23f6290dac03fd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $db23f6290dac03fd$export$2e2bcd8739ae039 = $db23f6290dac03fd$var$formatLong;

});

parcelRegister("4FbME", function(module, exports) {
$parcel$export(module.exports, "default", () => $365421c5e67e1a09$export$2e2bcd8739ae039);
var $365421c5e67e1a09$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $365421c5e67e1a09$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $365421c5e67e1a09$var$formatRelativeLocale[token];
};
var $365421c5e67e1a09$export$2e2bcd8739ae039 = $365421c5e67e1a09$var$formatRelative;

});

parcelRegister("lRRPG", function(module, exports) {
$parcel$export(module.exports, "default", () => $feb84e42f21fcad1$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $feb84e42f21fcad1$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $feb84e42f21fcad1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $feb84e42f21fcad1$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $feb84e42f21fcad1$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $feb84e42f21fcad1$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $feb84e42f21fcad1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $feb84e42f21fcad1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $feb84e42f21fcad1$var$localize = {
    ordinalNumber: $feb84e42f21fcad1$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $feb84e42f21fcad1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $feb84e42f21fcad1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $feb84e42f21fcad1$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $feb84e42f21fcad1$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $feb84e42f21fcad1$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $feb84e42f21fcad1$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $feb84e42f21fcad1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $feb84e42f21fcad1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $feb84e42f21fcad1$export$2e2bcd8739ae039 = $feb84e42f21fcad1$var$localize;

});

parcelRegister("hjR6o", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9bd66f881293945$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $c9bd66f881293945$var$matchOrdinalNumberPattern = /^\d+\./i;
var $c9bd66f881293945$var$parseOrdinalNumberPattern = /\d+/i;
var $c9bd66f881293945$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $c9bd66f881293945$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $c9bd66f881293945$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $c9bd66f881293945$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c9bd66f881293945$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $c9bd66f881293945$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $c9bd66f881293945$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $c9bd66f881293945$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $c9bd66f881293945$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $c9bd66f881293945$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $c9bd66f881293945$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $c9bd66f881293945$var$matchOrdinalNumberPattern,
        parsePattern: $c9bd66f881293945$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $c9bd66f881293945$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c9bd66f881293945$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $c9bd66f881293945$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c9bd66f881293945$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $c9bd66f881293945$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c9bd66f881293945$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $c9bd66f881293945$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c9bd66f881293945$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $c9bd66f881293945$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c9bd66f881293945$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c9bd66f881293945$export$2e2bcd8739ae039 = $c9bd66f881293945$var$match;

});


parcelRegister("1gMIg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ecd127267982ba1$export$2e2bcd8739ae039);

var $fo0JL = parcelRequire("fo0JL");

var $ijwoS = parcelRequire("ijwoS");

var $456g6 = parcelRequire("456g6");

var $c3Lnz = parcelRequire("c3Lnz");

var $1cDt7 = parcelRequire("1cDt7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $0ecd127267982ba1$var$locale = {
    code: 'fi',
    formatDistance: (0, $fo0JL.default),
    formatLong: (0, $ijwoS.default),
    formatRelative: (0, $456g6.default),
    localize: (0, $c3Lnz.default),
    match: (0, $1cDt7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0ecd127267982ba1$export$2e2bcd8739ae039 = $0ecd127267982ba1$var$locale;

});
parcelRegister("fo0JL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b339ab4932860e0a$export$2e2bcd8739ae039);
function $b339ab4932860e0a$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $b339ab4932860e0a$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $b339ab4932860e0a$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $b339ab4932860e0a$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $b339ab4932860e0a$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $b339ab4932860e0a$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $b339ab4932860e0a$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $b339ab4932860e0a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $b339ab4932860e0a$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $b339ab4932860e0a$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $b339ab4932860e0a$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $b339ab4932860e0a$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $b339ab4932860e0a$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $b339ab4932860e0a$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $b339ab4932860e0a$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $b339ab4932860e0a$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $b339ab4932860e0a$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $b339ab4932860e0a$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $b339ab4932860e0a$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $b339ab4932860e0a$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $b339ab4932860e0a$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $b339ab4932860e0a$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $b339ab4932860e0a$var$futureYears
    }
};
var $b339ab4932860e0a$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $b339ab4932860e0a$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $b339ab4932860e0a$export$2e2bcd8739ae039 = $b339ab4932860e0a$var$formatDistance;

});

parcelRegister("ijwoS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5532258287e4e2b$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $d5532258287e4e2b$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $d5532258287e4e2b$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $d5532258287e4e2b$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d5532258287e4e2b$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $d5532258287e4e2b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $d5532258287e4e2b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $d5532258287e4e2b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d5532258287e4e2b$export$2e2bcd8739ae039 = $d5532258287e4e2b$var$formatLong;

});

parcelRegister("456g6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f8c7be1f7ca8bfe$export$2e2bcd8739ae039);
var $2f8c7be1f7ca8bfe$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $2f8c7be1f7ca8bfe$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2f8c7be1f7ca8bfe$var$formatRelativeLocale[token];
};
var $2f8c7be1f7ca8bfe$export$2e2bcd8739ae039 = $2f8c7be1f7ca8bfe$var$formatRelative;

});

parcelRegister("c3Lnz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c7a8456e8dae17f$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $8c7a8456e8dae17f$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $8c7a8456e8dae17f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $8c7a8456e8dae17f$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $8c7a8456e8dae17f$var$formattingMonthValues = {
    narrow: $8c7a8456e8dae17f$var$monthValues.narrow,
    abbreviated: $8c7a8456e8dae17f$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $8c7a8456e8dae17f$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $8c7a8456e8dae17f$var$formattingDayValues = {
    narrow: $8c7a8456e8dae17f$var$dayValues.narrow,
    short: $8c7a8456e8dae17f$var$dayValues.short,
    abbreviated: $8c7a8456e8dae17f$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $8c7a8456e8dae17f$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $8c7a8456e8dae17f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $8c7a8456e8dae17f$var$localize = {
    ordinalNumber: $8c7a8456e8dae17f$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $8c7a8456e8dae17f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $8c7a8456e8dae17f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $8c7a8456e8dae17f$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $8c7a8456e8dae17f$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $8c7a8456e8dae17f$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $8c7a8456e8dae17f$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $8c7a8456e8dae17f$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $8c7a8456e8dae17f$export$2e2bcd8739ae039 = $8c7a8456e8dae17f$var$localize;

});

parcelRegister("1cDt7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e0587106d8e3ea7$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $0e0587106d8e3ea7$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $0e0587106d8e3ea7$var$parseOrdinalNumberPattern = /\d+/i;
var $0e0587106d8e3ea7$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $0e0587106d8e3ea7$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $0e0587106d8e3ea7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $0e0587106d8e3ea7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0e0587106d8e3ea7$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $0e0587106d8e3ea7$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $0e0587106d8e3ea7$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $0e0587106d8e3ea7$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $0e0587106d8e3ea7$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $0e0587106d8e3ea7$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $0e0587106d8e3ea7$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $0e0587106d8e3ea7$var$matchOrdinalNumberPattern,
        parsePattern: $0e0587106d8e3ea7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $0e0587106d8e3ea7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0e0587106d8e3ea7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $0e0587106d8e3ea7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0e0587106d8e3ea7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $0e0587106d8e3ea7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0e0587106d8e3ea7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $0e0587106d8e3ea7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0e0587106d8e3ea7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $0e0587106d8e3ea7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0e0587106d8e3ea7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0e0587106d8e3ea7$export$2e2bcd8739ae039 = $0e0587106d8e3ea7$var$match;

});


parcelRegister("3Ebby", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a7dc8b3f537b964$export$2e2bcd8739ae039);

var $gAs9G = parcelRequire("gAs9G");

var $3ONTk = parcelRequire("3ONTk");

var $iMCHK = parcelRequire("iMCHK");

var $g8dHc = parcelRequire("g8dHc");

var $l910G = parcelRequire("l910G");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $2a7dc8b3f537b964$var$locale = {
    code: 'fr',
    formatDistance: (0, $gAs9G.default),
    formatLong: (0, $3ONTk.default),
    formatRelative: (0, $iMCHK.default),
    localize: (0, $g8dHc.default),
    match: (0, $l910G.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2a7dc8b3f537b964$export$2e2bcd8739ae039 = $2a7dc8b3f537b964$var$locale;

});
parcelRegister("gAs9G", function(module, exports) {
$parcel$export(module.exports, "default", () => $c135d92fbbd6cd82$export$2e2bcd8739ae039);
var $c135d92fbbd6cd82$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $c135d92fbbd6cd82$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $c135d92fbbd6cd82$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $c135d92fbbd6cd82$export$2e2bcd8739ae039 = $c135d92fbbd6cd82$var$formatDistance;

});

parcelRegister("3ONTk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c7cbe04bad2ca47$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $2c7cbe04bad2ca47$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $2c7cbe04bad2ca47$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $2c7cbe04bad2ca47$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2c7cbe04bad2ca47$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $2c7cbe04bad2ca47$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $2c7cbe04bad2ca47$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $2c7cbe04bad2ca47$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2c7cbe04bad2ca47$export$2e2bcd8739ae039 = $2c7cbe04bad2ca47$var$formatLong;

});

parcelRegister("iMCHK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0387661f6009ad7f$export$2e2bcd8739ae039);
var $0387661f6009ad7f$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $0387661f6009ad7f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0387661f6009ad7f$var$formatRelativeLocale[token];
};
var $0387661f6009ad7f$export$2e2bcd8739ae039 = $0387661f6009ad7f$var$formatRelative;

});

parcelRegister("g8dHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbe804607993a847$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $bbe804607993a847$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $bbe804607993a847$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $bbe804607993a847$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $bbe804607993a847$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $bbe804607993a847$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $bbe804607993a847$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $bbe804607993a847$var$localize = {
    ordinalNumber: $bbe804607993a847$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $bbe804607993a847$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $bbe804607993a847$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $bbe804607993a847$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $bbe804607993a847$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $bbe804607993a847$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $bbe804607993a847$export$2e2bcd8739ae039 = $bbe804607993a847$var$localize;

});

parcelRegister("l910G", function(module, exports) {
$parcel$export(module.exports, "default", () => $f64b38ce032124b3$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $f64b38ce032124b3$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $f64b38ce032124b3$var$parseOrdinalNumberPattern = /\d+/i;
var $f64b38ce032124b3$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $f64b38ce032124b3$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $f64b38ce032124b3$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $f64b38ce032124b3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f64b38ce032124b3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $f64b38ce032124b3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f64b38ce032124b3$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $f64b38ce032124b3$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $f64b38ce032124b3$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $f64b38ce032124b3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $f64b38ce032124b3$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $f64b38ce032124b3$var$matchOrdinalNumberPattern,
        parsePattern: $f64b38ce032124b3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $f64b38ce032124b3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f64b38ce032124b3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $f64b38ce032124b3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f64b38ce032124b3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $f64b38ce032124b3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f64b38ce032124b3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $f64b38ce032124b3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f64b38ce032124b3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $f64b38ce032124b3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f64b38ce032124b3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f64b38ce032124b3$export$2e2bcd8739ae039 = $f64b38ce032124b3$var$match;

});


parcelRegister("3KVTM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bc294738dee28e2$export$2e2bcd8739ae039);

var $b4eg5 = parcelRequire("b4eg5");

var $kfBdx = parcelRequire("kfBdx");

var $lEAKw = parcelRequire("lEAKw");

var $CT7Xo = parcelRequire("CT7Xo");

var $lD5QE = parcelRequire("lD5QE");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $2bc294738dee28e2$var$locale = {
    code: 'hu',
    formatDistance: (0, $b4eg5.default),
    formatLong: (0, $kfBdx.default),
    formatRelative: (0, $lEAKw.default),
    localize: (0, $CT7Xo.default),
    match: (0, $lD5QE.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2bc294738dee28e2$export$2e2bcd8739ae039 = $2bc294738dee28e2$var$locale;

});
parcelRegister("b4eg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $80eb20de7fa76585$export$2e2bcd8739ae039);
var $80eb20de7fa76585$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $80eb20de7fa76585$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $80eb20de7fa76585$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $80eb20de7fa76585$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $80eb20de7fa76585$var$withSuffixes[key][comparison] : $80eb20de7fa76585$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $80eb20de7fa76585$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $80eb20de7fa76585$export$2e2bcd8739ae039 = $80eb20de7fa76585$var$formatDistance;

});

parcelRegister("kfBdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe213f522afe85d$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $ebe213f522afe85d$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $ebe213f522afe85d$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $ebe213f522afe85d$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ebe213f522afe85d$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $ebe213f522afe85d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $ebe213f522afe85d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $ebe213f522afe85d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ebe213f522afe85d$export$2e2bcd8739ae039 = $ebe213f522afe85d$var$formatLong;

});

parcelRegister("lEAKw", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc39d7153baa2807$export$2e2bcd8739ae039);
var $fc39d7153baa2807$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $fc39d7153baa2807$var$week(isFuture) {
    return function(date) {
        var weekday = $fc39d7153baa2807$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $fc39d7153baa2807$var$formatRelativeLocale = {
    lastWeek: $fc39d7153baa2807$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $fc39d7153baa2807$var$week(true),
    other: 'P'
};
var $fc39d7153baa2807$var$formatRelative = function formatRelative(token, date) {
    var format = $fc39d7153baa2807$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $fc39d7153baa2807$export$2e2bcd8739ae039 = $fc39d7153baa2807$var$formatRelative;

});

parcelRegister("CT7Xo", function(module, exports) {
$parcel$export(module.exports, "default", () => $074e4fdd79e9a7e6$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $074e4fdd79e9a7e6$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $074e4fdd79e9a7e6$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $074e4fdd79e9a7e6$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $074e4fdd79e9a7e6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $074e4fdd79e9a7e6$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $074e4fdd79e9a7e6$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $074e4fdd79e9a7e6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $074e4fdd79e9a7e6$var$localize = {
    ordinalNumber: $074e4fdd79e9a7e6$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $074e4fdd79e9a7e6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $074e4fdd79e9a7e6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $074e4fdd79e9a7e6$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $4JSD1.default)({
        values: $074e4fdd79e9a7e6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $074e4fdd79e9a7e6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $074e4fdd79e9a7e6$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $074e4fdd79e9a7e6$export$2e2bcd8739ae039 = $074e4fdd79e9a7e6$var$localize;

});

parcelRegister("lD5QE", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbf1c6d464a2e9de$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $fbf1c6d464a2e9de$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $fbf1c6d464a2e9de$var$parseOrdinalNumberPattern = /\d+/i;
var $fbf1c6d464a2e9de$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $fbf1c6d464a2e9de$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $fbf1c6d464a2e9de$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $fbf1c6d464a2e9de$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $fbf1c6d464a2e9de$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $fbf1c6d464a2e9de$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fbf1c6d464a2e9de$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $fbf1c6d464a2e9de$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $fbf1c6d464a2e9de$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $fbf1c6d464a2e9de$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $fbf1c6d464a2e9de$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $fbf1c6d464a2e9de$var$matchOrdinalNumberPattern,
        parsePattern: $fbf1c6d464a2e9de$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $fbf1c6d464a2e9de$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fbf1c6d464a2e9de$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $fbf1c6d464a2e9de$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fbf1c6d464a2e9de$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $fbf1c6d464a2e9de$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fbf1c6d464a2e9de$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $fbf1c6d464a2e9de$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fbf1c6d464a2e9de$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $fbf1c6d464a2e9de$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fbf1c6d464a2e9de$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fbf1c6d464a2e9de$export$2e2bcd8739ae039 = $fbf1c6d464a2e9de$var$match;

});


parcelRegister("38dan", function(module, exports) {
$parcel$export(module.exports, "default", () => $247c550720960aaf$export$2e2bcd8739ae039);

var $12UCL = parcelRequire("12UCL");

var $eBreU = parcelRequire("eBreU");

var $8J78h = parcelRequire("8J78h");

var $eBFjk = parcelRequire("eBFjk");

var $a6Z9W = parcelRequire("a6Z9W");
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $247c550720960aaf$var$locale = {
    code: 'is',
    formatDistance: (0, $12UCL.default),
    formatLong: (0, $eBreU.default),
    formatRelative: (0, $8J78h.default),
    localize: (0, $eBFjk.default),
    match: (0, $a6Z9W.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $247c550720960aaf$export$2e2bcd8739ae039 = $247c550720960aaf$var$locale;

});
parcelRegister("12UCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c31e6ba1d0d9aad$export$2e2bcd8739ae039);
var $0c31e6ba1d0d9aad$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $0c31e6ba1d0d9aad$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0c31e6ba1d0d9aad$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $0c31e6ba1d0d9aad$export$2e2bcd8739ae039 = $0c31e6ba1d0d9aad$var$formatDistance;

});

parcelRegister("eBreU", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa19a693e6f72b88$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $aa19a693e6f72b88$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $aa19a693e6f72b88$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aa19a693e6f72b88$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $aa19a693e6f72b88$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $aa19a693e6f72b88$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $aa19a693e6f72b88$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $aa19a693e6f72b88$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aa19a693e6f72b88$export$2e2bcd8739ae039 = $aa19a693e6f72b88$var$formatLong;

});

parcelRegister("8J78h", function(module, exports) {
$parcel$export(module.exports, "default", () => $65a80f0d1d82972c$export$2e2bcd8739ae039);
var $65a80f0d1d82972c$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $65a80f0d1d82972c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $65a80f0d1d82972c$var$formatRelativeLocale[token];
};
var $65a80f0d1d82972c$export$2e2bcd8739ae039 = $65a80f0d1d82972c$var$formatRelative;

});

parcelRegister("eBFjk", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa2490dda64f1b27$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $aa2490dda64f1b27$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $aa2490dda64f1b27$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $aa2490dda64f1b27$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $aa2490dda64f1b27$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $aa2490dda64f1b27$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $aa2490dda64f1b27$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $aa2490dda64f1b27$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $aa2490dda64f1b27$var$localize = {
    ordinalNumber: $aa2490dda64f1b27$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $aa2490dda64f1b27$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $aa2490dda64f1b27$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $aa2490dda64f1b27$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $aa2490dda64f1b27$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $aa2490dda64f1b27$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $aa2490dda64f1b27$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $aa2490dda64f1b27$export$2e2bcd8739ae039 = $aa2490dda64f1b27$var$localize;

});

parcelRegister("a6Z9W", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c9e7dfdc1c84cf$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $75c9e7dfdc1c84cf$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $75c9e7dfdc1c84cf$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $75c9e7dfdc1c84cf$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $75c9e7dfdc1c84cf$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $75c9e7dfdc1c84cf$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $75c9e7dfdc1c84cf$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $75c9e7dfdc1c84cf$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $75c9e7dfdc1c84cf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $75c9e7dfdc1c84cf$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $75c9e7dfdc1c84cf$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $75c9e7dfdc1c84cf$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $75c9e7dfdc1c84cf$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $75c9e7dfdc1c84cf$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $75c9e7dfdc1c84cf$var$matchOrdinalNumberPattern,
        parsePattern: $75c9e7dfdc1c84cf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $75c9e7dfdc1c84cf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $75c9e7dfdc1c84cf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $75c9e7dfdc1c84cf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $75c9e7dfdc1c84cf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $75c9e7dfdc1c84cf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $75c9e7dfdc1c84cf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $75c9e7dfdc1c84cf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $75c9e7dfdc1c84cf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $75c9e7dfdc1c84cf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $75c9e7dfdc1c84cf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $75c9e7dfdc1c84cf$export$2e2bcd8739ae039 = $75c9e7dfdc1c84cf$var$match;

});


parcelRegister("jg8SG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e05666893c646800$export$2e2bcd8739ae039);

var $21x19 = parcelRequire("21x19");

var $3CMMq = parcelRequire("3CMMq");

var $e1pJQ = parcelRequire("e1pJQ");

var $9Xxs3 = parcelRequire("9Xxs3");

var $lkheX = parcelRequire("lkheX");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $e05666893c646800$var$locale = {
    code: 'it',
    formatDistance: (0, $21x19.default),
    formatLong: (0, $3CMMq.default),
    formatRelative: (0, $e1pJQ.default),
    localize: (0, $9Xxs3.default),
    match: (0, $lkheX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e05666893c646800$export$2e2bcd8739ae039 = $e05666893c646800$var$locale;

});
parcelRegister("21x19", function(module, exports) {
$parcel$export(module.exports, "default", () => $179549627b3d696d$export$2e2bcd8739ae039);
var $179549627b3d696d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $179549627b3d696d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $179549627b3d696d$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $179549627b3d696d$export$2e2bcd8739ae039 = $179549627b3d696d$var$formatDistance;

});

parcelRegister("3CMMq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a3ac26ab6238a63$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $2a3ac26ab6238a63$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $2a3ac26ab6238a63$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $2a3ac26ab6238a63$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $2a3ac26ab6238a63$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $2a3ac26ab6238a63$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $2a3ac26ab6238a63$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $2a3ac26ab6238a63$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2a3ac26ab6238a63$export$2e2bcd8739ae039 = $2a3ac26ab6238a63$var$formatLong;

});

parcelRegister("e1pJQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3551fca8af85eb7$export$2e2bcd8739ae039);

var $2vhsi = parcelRequire("2vhsi");
var $a3551fca8af85eb7$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $a3551fca8af85eb7$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $a3551fca8af85eb7$var$weekdays[day] + " scorso alle' p";
    }
}
function $a3551fca8af85eb7$var$thisWeek(day) {
    return "'" + $a3551fca8af85eb7$var$weekdays[day] + " alle' p";
}
function $a3551fca8af85eb7$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $a3551fca8af85eb7$var$weekdays[day] + " prossimo alle' p";
    }
}
var $a3551fca8af85eb7$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $a3551fca8af85eb7$var$thisWeek(day);
        else return $a3551fca8af85eb7$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $a3551fca8af85eb7$var$thisWeek(day);
        else return $a3551fca8af85eb7$var$_nextWeek(day);
    },
    other: 'P'
};
var $a3551fca8af85eb7$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $a3551fca8af85eb7$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $a3551fca8af85eb7$export$2e2bcd8739ae039 = $a3551fca8af85eb7$var$formatRelative;

});
parcelRegister("2vhsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d2c044be7b70a29$export$2e2bcd8739ae039);

var $eZ0fw = parcelRequire("eZ0fw");

var $iCjwa = parcelRequire("iCjwa");
function $1d2c044be7b70a29$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $eZ0fw.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $iCjwa.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $iCjwa.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});


parcelRegister("9Xxs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $74039280d2db1ffe$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $74039280d2db1ffe$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $74039280d2db1ffe$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $74039280d2db1ffe$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $74039280d2db1ffe$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $74039280d2db1ffe$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $74039280d2db1ffe$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $74039280d2db1ffe$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $74039280d2db1ffe$var$localize = {
    ordinalNumber: $74039280d2db1ffe$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $74039280d2db1ffe$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $74039280d2db1ffe$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $74039280d2db1ffe$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $74039280d2db1ffe$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $74039280d2db1ffe$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $74039280d2db1ffe$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $74039280d2db1ffe$export$2e2bcd8739ae039 = $74039280d2db1ffe$var$localize;

});

parcelRegister("lkheX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f868d6c7ae326052$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $f868d6c7ae326052$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $f868d6c7ae326052$var$parseOrdinalNumberPattern = /\d+/i;
var $f868d6c7ae326052$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $f868d6c7ae326052$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $f868d6c7ae326052$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $f868d6c7ae326052$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f868d6c7ae326052$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $f868d6c7ae326052$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f868d6c7ae326052$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $f868d6c7ae326052$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $f868d6c7ae326052$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $f868d6c7ae326052$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $f868d6c7ae326052$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $f868d6c7ae326052$var$matchOrdinalNumberPattern,
        parsePattern: $f868d6c7ae326052$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $f868d6c7ae326052$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f868d6c7ae326052$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $f868d6c7ae326052$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f868d6c7ae326052$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $f868d6c7ae326052$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f868d6c7ae326052$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $f868d6c7ae326052$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f868d6c7ae326052$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $f868d6c7ae326052$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f868d6c7ae326052$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f868d6c7ae326052$export$2e2bcd8739ae039 = $f868d6c7ae326052$var$match;

});


parcelRegister("llQgT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8b41b2e0fb41fd3$export$2e2bcd8739ae039);

var $1R2F0 = parcelRequire("1R2F0");

var $03xAG = parcelRequire("03xAG");

var $VjGW1 = parcelRequire("VjGW1");

var $bMFyV = parcelRequire("bMFyV");

var $6QSXb = parcelRequire("6QSXb");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $f8b41b2e0fb41fd3$var$locale = {
    code: 'ja',
    formatDistance: (0, $1R2F0.default),
    formatLong: (0, $03xAG.default),
    formatRelative: (0, $VjGW1.default),
    localize: (0, $bMFyV.default),
    match: (0, $6QSXb.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f8b41b2e0fb41fd3$export$2e2bcd8739ae039 = $f8b41b2e0fb41fd3$var$locale;

});
parcelRegister("1R2F0", function(module, exports) {
$parcel$export(module.exports, "default", () => $159ccdf4f5277793$export$2e2bcd8739ae039);
var $159ccdf4f5277793$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $159ccdf4f5277793$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $159ccdf4f5277793$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $159ccdf4f5277793$export$2e2bcd8739ae039 = $159ccdf4f5277793$var$formatDistance;

});

parcelRegister("03xAG", function(module, exports) {
$parcel$export(module.exports, "default", () => $00aa5655dcf20610$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $00aa5655dcf20610$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $00aa5655dcf20610$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $00aa5655dcf20610$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $00aa5655dcf20610$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $00aa5655dcf20610$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $00aa5655dcf20610$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $00aa5655dcf20610$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $00aa5655dcf20610$export$2e2bcd8739ae039 = $00aa5655dcf20610$var$formatLong;

});

parcelRegister("VjGW1", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac4994ea5795400$export$2e2bcd8739ae039);
var $0ac4994ea5795400$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $0ac4994ea5795400$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0ac4994ea5795400$var$formatRelativeLocale[token];
};
var $0ac4994ea5795400$export$2e2bcd8739ae039 = $0ac4994ea5795400$var$formatRelative;

});

parcelRegister("bMFyV", function(module, exports) {
$parcel$export(module.exports, "default", () => $89446acb3af0f4a7$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $89446acb3af0f4a7$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $89446acb3af0f4a7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $89446acb3af0f4a7$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $89446acb3af0f4a7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $89446acb3af0f4a7$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $89446acb3af0f4a7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $89446acb3af0f4a7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $89446acb3af0f4a7$var$localize = {
    ordinalNumber: $89446acb3af0f4a7$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $89446acb3af0f4a7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $89446acb3af0f4a7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $89446acb3af0f4a7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $89446acb3af0f4a7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $89446acb3af0f4a7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $89446acb3af0f4a7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $89446acb3af0f4a7$export$2e2bcd8739ae039 = $89446acb3af0f4a7$var$localize;

});

parcelRegister("6QSXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd23a07ab430d14$export$2e2bcd8739ae039);

var $lXxnR = parcelRequire("lXxnR");

var $9R4Zi = parcelRequire("9R4Zi");
var $4fd23a07ab430d14$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $4fd23a07ab430d14$var$parseOrdinalNumberPattern = /\d+/i;
var $4fd23a07ab430d14$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $4fd23a07ab430d14$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $4fd23a07ab430d14$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $4fd23a07ab430d14$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $4fd23a07ab430d14$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $4fd23a07ab430d14$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $4fd23a07ab430d14$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $4fd23a07ab430d14$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $4fd23a07ab430d14$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $4fd23a07ab430d14$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $4fd23a07ab430d14$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $4fd23a07ab430d14$var$matchOrdinalNumberPattern,
        parsePattern: $4fd23a07ab430d14$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $4fd23a07ab430d14$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4fd23a07ab430d14$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $4fd23a07ab430d14$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4fd23a07ab430d14$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $4fd23a07ab430d14$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4fd23a07ab430d14$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $4fd23a07ab430d14$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4fd23a07ab430d14$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $4fd23a07ab430d14$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4fd23a07ab430d14$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4fd23a07ab430d14$export$2e2bcd8739ae039 = $4fd23a07ab430d14$var$match;

});


parcelRegister("cwzke", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e3e00c38dd58d3$export$2e2bcd8739ae039);

var $5gcrw = parcelRequire("5gcrw");

var $3VqNo = parcelRequire("3VqNo");

var $3f7vZ = parcelRequire("3f7vZ");

var $cNcsM = parcelRequire("cNcsM");

var $ikGjP = parcelRequire("ikGjP");
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $91e3e00c38dd58d3$var$locale = {
    code: 'ko',
    formatDistance: (0, $5gcrw.default),
    formatLong: (0, $3VqNo.default),
    formatRelative: (0, $3f7vZ.default),
    localize: (0, $cNcsM.default),
    match: (0, $ikGjP.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $91e3e00c38dd58d3$export$2e2bcd8739ae039 = $91e3e00c38dd58d3$var$locale;

});
parcelRegister("5gcrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d481940c2fd0100$export$2e2bcd8739ae039);
var $3d481940c2fd0100$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $3d481940c2fd0100$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3d481940c2fd0100$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $3d481940c2fd0100$export$2e2bcd8739ae039 = $3d481940c2fd0100$var$formatDistance;

});

parcelRegister("3VqNo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dbb7b0cf15d9fe3$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $2dbb7b0cf15d9fe3$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $2dbb7b0cf15d9fe3$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $2dbb7b0cf15d9fe3$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $2dbb7b0cf15d9fe3$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $2dbb7b0cf15d9fe3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $2dbb7b0cf15d9fe3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $2dbb7b0cf15d9fe3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2dbb7b0cf15d9fe3$export$2e2bcd8739ae039 = $2dbb7b0cf15d9fe3$var$formatLong;

});

parcelRegister("3f7vZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c89a20ba8a488e$export$2e2bcd8739ae039);
var $25c89a20ba8a488e$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $25c89a20ba8a488e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $25c89a20ba8a488e$var$formatRelativeLocale[token];
};
var $25c89a20ba8a488e$export$2e2bcd8739ae039 = $25c89a20ba8a488e$var$formatRelative;

});

parcelRegister("cNcsM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9503ba95504ac91c$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $9503ba95504ac91c$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $9503ba95504ac91c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $9503ba95504ac91c$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $9503ba95504ac91c$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $9503ba95504ac91c$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $9503ba95504ac91c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $9503ba95504ac91c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $9503ba95504ac91c$var$localize = {
    ordinalNumber: $9503ba95504ac91c$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $9503ba95504ac91c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $9503ba95504ac91c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $9503ba95504ac91c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $9503ba95504ac91c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $9503ba95504ac91c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9503ba95504ac91c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9503ba95504ac91c$export$2e2bcd8739ae039 = $9503ba95504ac91c$var$localize;

});

parcelRegister("ikGjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d58aebdd1d89c432$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $d58aebdd1d89c432$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $d58aebdd1d89c432$var$parseOrdinalNumberPattern = /\d+/i;
var $d58aebdd1d89c432$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $d58aebdd1d89c432$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $d58aebdd1d89c432$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $d58aebdd1d89c432$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d58aebdd1d89c432$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $d58aebdd1d89c432$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $d58aebdd1d89c432$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $d58aebdd1d89c432$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $d58aebdd1d89c432$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $d58aebdd1d89c432$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $d58aebdd1d89c432$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $d58aebdd1d89c432$var$matchOrdinalNumberPattern,
        parsePattern: $d58aebdd1d89c432$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $d58aebdd1d89c432$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d58aebdd1d89c432$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $d58aebdd1d89c432$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d58aebdd1d89c432$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $d58aebdd1d89c432$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d58aebdd1d89c432$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $d58aebdd1d89c432$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d58aebdd1d89c432$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $d58aebdd1d89c432$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d58aebdd1d89c432$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d58aebdd1d89c432$export$2e2bcd8739ae039 = $d58aebdd1d89c432$var$match;

});


parcelRegister("6Xp2p", function(module, exports) {
$parcel$export(module.exports, "default", () => $510bacc5b290d043$export$2e2bcd8739ae039);

var $e9gtI = parcelRequire("e9gtI");

var $zrvCb = parcelRequire("zrvCb");

var $an6MD = parcelRequire("an6MD");

var $cCyQ6 = parcelRequire("cCyQ6");

var $auE9r = parcelRequire("auE9r");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $510bacc5b290d043$var$locale = {
    code: 'nb',
    formatDistance: (0, $e9gtI.default),
    formatLong: (0, $zrvCb.default),
    formatRelative: (0, $an6MD.default),
    localize: (0, $cCyQ6.default),
    match: (0, $auE9r.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $510bacc5b290d043$export$2e2bcd8739ae039 = $510bacc5b290d043$var$locale;

});
parcelRegister("e9gtI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ceb037e6abef95$export$2e2bcd8739ae039);
var $a4ceb037e6abef95$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $a4ceb037e6abef95$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a4ceb037e6abef95$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $a4ceb037e6abef95$export$2e2bcd8739ae039 = $a4ceb037e6abef95$var$formatDistance;

});

parcelRegister("zrvCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $06a89bb26f1b74e0$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $06a89bb26f1b74e0$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $06a89bb26f1b74e0$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $06a89bb26f1b74e0$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $06a89bb26f1b74e0$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $06a89bb26f1b74e0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $06a89bb26f1b74e0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $06a89bb26f1b74e0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $06a89bb26f1b74e0$export$2e2bcd8739ae039 = $06a89bb26f1b74e0$var$formatLong;

});

parcelRegister("an6MD", function(module, exports) {
$parcel$export(module.exports, "default", () => $78d1506707ef465e$export$2e2bcd8739ae039);
var $78d1506707ef465e$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $78d1506707ef465e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $78d1506707ef465e$var$formatRelativeLocale[token];
};
var $78d1506707ef465e$export$2e2bcd8739ae039 = $78d1506707ef465e$var$formatRelative;

});

parcelRegister("cCyQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $93040f00397c01b2$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $93040f00397c01b2$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $93040f00397c01b2$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $93040f00397c01b2$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $93040f00397c01b2$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $93040f00397c01b2$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $93040f00397c01b2$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $93040f00397c01b2$var$localize = {
    ordinalNumber: $93040f00397c01b2$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $93040f00397c01b2$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $93040f00397c01b2$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $93040f00397c01b2$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $93040f00397c01b2$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $93040f00397c01b2$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $93040f00397c01b2$export$2e2bcd8739ae039 = $93040f00397c01b2$var$localize;

});

parcelRegister("auE9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a3bd9eb8f3f8d82$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $7a3bd9eb8f3f8d82$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $7a3bd9eb8f3f8d82$var$parseOrdinalNumberPattern = /\d+/i;
var $7a3bd9eb8f3f8d82$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $7a3bd9eb8f3f8d82$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $7a3bd9eb8f3f8d82$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $7a3bd9eb8f3f8d82$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7a3bd9eb8f3f8d82$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $7a3bd9eb8f3f8d82$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7a3bd9eb8f3f8d82$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $7a3bd9eb8f3f8d82$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $7a3bd9eb8f3f8d82$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $7a3bd9eb8f3f8d82$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $7a3bd9eb8f3f8d82$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $7a3bd9eb8f3f8d82$var$matchOrdinalNumberPattern,
        parsePattern: $7a3bd9eb8f3f8d82$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $7a3bd9eb8f3f8d82$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3bd9eb8f3f8d82$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $7a3bd9eb8f3f8d82$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3bd9eb8f3f8d82$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $7a3bd9eb8f3f8d82$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3bd9eb8f3f8d82$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $7a3bd9eb8f3f8d82$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3bd9eb8f3f8d82$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $7a3bd9eb8f3f8d82$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7a3bd9eb8f3f8d82$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7a3bd9eb8f3f8d82$export$2e2bcd8739ae039 = $7a3bd9eb8f3f8d82$var$match;

});


parcelRegister("auqJr", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a31711d152c6a73$export$2e2bcd8739ae039);

var $ff0Io = parcelRequire("ff0Io");

var $9WNKS = parcelRequire("9WNKS");

var $bvuQ5 = parcelRequire("bvuQ5");

var $9MzjW = parcelRequire("9MzjW");

var $2ZcGM = parcelRequire("2ZcGM");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $7a31711d152c6a73$var$locale = {
    code: 'nl',
    formatDistance: (0, $ff0Io.default),
    formatLong: (0, $9WNKS.default),
    formatRelative: (0, $bvuQ5.default),
    localize: (0, $9MzjW.default),
    match: (0, $2ZcGM.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7a31711d152c6a73$export$2e2bcd8739ae039 = $7a31711d152c6a73$var$locale;

});
parcelRegister("ff0Io", function(module, exports) {
$parcel$export(module.exports, "default", () => $b188cfbb959e2c6c$export$2e2bcd8739ae039);
var $b188cfbb959e2c6c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $b188cfbb959e2c6c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b188cfbb959e2c6c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $b188cfbb959e2c6c$export$2e2bcd8739ae039 = $b188cfbb959e2c6c$var$formatDistance;

});

parcelRegister("9WNKS", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e0202be4dc4433$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $73e0202be4dc4433$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $73e0202be4dc4433$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $73e0202be4dc4433$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $73e0202be4dc4433$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $73e0202be4dc4433$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $73e0202be4dc4433$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $73e0202be4dc4433$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $73e0202be4dc4433$export$2e2bcd8739ae039 = $73e0202be4dc4433$var$formatLong;

});

parcelRegister("bvuQ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $860a82fb237e3983$export$2e2bcd8739ae039);
var $860a82fb237e3983$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $860a82fb237e3983$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $860a82fb237e3983$var$formatRelativeLocale[token];
};
var $860a82fb237e3983$export$2e2bcd8739ae039 = $860a82fb237e3983$var$formatRelative;

});

parcelRegister("9MzjW", function(module, exports) {
$parcel$export(module.exports, "default", () => $71f3feac59bad141$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $71f3feac59bad141$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $71f3feac59bad141$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $71f3feac59bad141$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $71f3feac59bad141$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $71f3feac59bad141$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $71f3feac59bad141$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $71f3feac59bad141$var$localize = {
    ordinalNumber: $71f3feac59bad141$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $71f3feac59bad141$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $71f3feac59bad141$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $71f3feac59bad141$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $71f3feac59bad141$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $71f3feac59bad141$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $71f3feac59bad141$export$2e2bcd8739ae039 = $71f3feac59bad141$var$localize;

});

parcelRegister("2ZcGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $22cb1f0ff0fb69f9$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $22cb1f0ff0fb69f9$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $22cb1f0ff0fb69f9$var$parseOrdinalNumberPattern = /\d+/i;
var $22cb1f0ff0fb69f9$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $22cb1f0ff0fb69f9$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $22cb1f0ff0fb69f9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $22cb1f0ff0fb69f9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $22cb1f0ff0fb69f9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $22cb1f0ff0fb69f9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $22cb1f0ff0fb69f9$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $22cb1f0ff0fb69f9$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $22cb1f0ff0fb69f9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $22cb1f0ff0fb69f9$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $22cb1f0ff0fb69f9$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $22cb1f0ff0fb69f9$var$matchOrdinalNumberPattern,
        parsePattern: $22cb1f0ff0fb69f9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $22cb1f0ff0fb69f9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $22cb1f0ff0fb69f9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $22cb1f0ff0fb69f9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $22cb1f0ff0fb69f9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $22cb1f0ff0fb69f9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $22cb1f0ff0fb69f9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $22cb1f0ff0fb69f9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $22cb1f0ff0fb69f9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $22cb1f0ff0fb69f9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $22cb1f0ff0fb69f9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $22cb1f0ff0fb69f9$export$2e2bcd8739ae039 = $22cb1f0ff0fb69f9$var$match;

});


parcelRegister("aC2nL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b9f4d10eff96079$export$2e2bcd8739ae039);

var $dorIT = parcelRequire("dorIT");

var $a6vm3 = parcelRequire("a6vm3");

var $aRQR6 = parcelRequire("aRQR6");

var $d2rdV = parcelRequire("d2rdV");

var $4AhYj = parcelRequire("4AhYj");
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $7b9f4d10eff96079$var$locale = {
    code: 'pl',
    formatDistance: (0, $dorIT.default),
    formatLong: (0, $a6vm3.default),
    formatRelative: (0, $aRQR6.default),
    localize: (0, $d2rdV.default),
    match: (0, $4AhYj.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7b9f4d10eff96079$export$2e2bcd8739ae039 = $7b9f4d10eff96079$var$locale;

});
parcelRegister("dorIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c03057833364b11$export$2e2bcd8739ae039);
var $9c03057833364b11$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $9c03057833364b11$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $9c03057833364b11$var$declension(scheme, count, time) {
    var group = $9c03057833364b11$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $9c03057833364b11$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $9c03057833364b11$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $9c03057833364b11$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $9c03057833364b11$var$declension(scheme, count, 'future');
    else return $9c03057833364b11$var$declension(scheme, count, 'past') + ' temu';
};
var $9c03057833364b11$export$2e2bcd8739ae039 = $9c03057833364b11$var$formatDistance;

});

parcelRegister("a6vm3", function(module, exports) {
$parcel$export(module.exports, "default", () => $75b2c94a5dbd0a4a$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $75b2c94a5dbd0a4a$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $75b2c94a5dbd0a4a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $75b2c94a5dbd0a4a$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $75b2c94a5dbd0a4a$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $75b2c94a5dbd0a4a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $75b2c94a5dbd0a4a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $75b2c94a5dbd0a4a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $75b2c94a5dbd0a4a$export$2e2bcd8739ae039 = $75b2c94a5dbd0a4a$var$formatLong;

});

parcelRegister("aRQR6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e97da9fb94dd0f5$export$2e2bcd8739ae039);

var $2vhsi = parcelRequire("2vhsi");
var $7e97da9fb94dd0f5$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $7e97da9fb94dd0f5$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $7e97da9fb94dd0f5$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $7e97da9fb94dd0f5$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $7e97da9fb94dd0f5$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $2vhsi.default)(date, baseDate, options)) adjectives = $7e97da9fb94dd0f5$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $7e97da9fb94dd0f5$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $7e97da9fb94dd0f5$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $7e97da9fb94dd0f5$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $7e97da9fb94dd0f5$var$formatRelativeLocale = {
    lastWeek: $7e97da9fb94dd0f5$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $7e97da9fb94dd0f5$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $7e97da9fb94dd0f5$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $7e97da9fb94dd0f5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $7e97da9fb94dd0f5$export$2e2bcd8739ae039 = $7e97da9fb94dd0f5$var$formatRelative;

});

parcelRegister("d2rdV", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e0945166c848ea$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $97e0945166c848ea$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $97e0945166c848ea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $97e0945166c848ea$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $97e0945166c848ea$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $97e0945166c848ea$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $97e0945166c848ea$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $97e0945166c848ea$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $97e0945166c848ea$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $97e0945166c848ea$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $97e0945166c848ea$var$localize = {
    ordinalNumber: $97e0945166c848ea$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $97e0945166c848ea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $97e0945166c848ea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $97e0945166c848ea$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $97e0945166c848ea$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $97e0945166c848ea$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $97e0945166c848ea$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $97e0945166c848ea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $97e0945166c848ea$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $97e0945166c848ea$export$2e2bcd8739ae039 = $97e0945166c848ea$var$localize;

});

parcelRegister("4AhYj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3568770ce992e97a$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $3568770ce992e97a$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $3568770ce992e97a$var$parseOrdinalNumberPattern = /\d+/i;
var $3568770ce992e97a$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $3568770ce992e97a$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $3568770ce992e97a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $3568770ce992e97a$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $3568770ce992e97a$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $3568770ce992e97a$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $3568770ce992e97a$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $3568770ce992e97a$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $3568770ce992e97a$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $3568770ce992e97a$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $3568770ce992e97a$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $3568770ce992e97a$var$matchOrdinalNumberPattern,
        parsePattern: $3568770ce992e97a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $3568770ce992e97a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3568770ce992e97a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $3568770ce992e97a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3568770ce992e97a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $3568770ce992e97a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3568770ce992e97a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $3568770ce992e97a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3568770ce992e97a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $3568770ce992e97a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3568770ce992e97a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3568770ce992e97a$export$2e2bcd8739ae039 = $3568770ce992e97a$var$match;

});


parcelRegister("4BqSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $359f779fdeb3cfaf$export$2e2bcd8739ae039);

var $kDpmy = parcelRequire("kDpmy");

var $fnY1g = parcelRequire("fnY1g");

var $fx8z1 = parcelRequire("fx8z1");

var $eSXEA = parcelRequire("eSXEA");

var $ggrPo = parcelRequire("ggrPo");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $359f779fdeb3cfaf$var$locale = {
    code: 'pt',
    formatDistance: (0, $kDpmy.default),
    formatLong: (0, $fnY1g.default),
    formatRelative: (0, $fx8z1.default),
    localize: (0, $eSXEA.default),
    match: (0, $ggrPo.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $359f779fdeb3cfaf$export$2e2bcd8739ae039 = $359f779fdeb3cfaf$var$locale;

});
parcelRegister("kDpmy", function(module, exports) {
$parcel$export(module.exports, "default", () => $f05b1fb586d61e4e$export$2e2bcd8739ae039);
var $f05b1fb586d61e4e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $f05b1fb586d61e4e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f05b1fb586d61e4e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $f05b1fb586d61e4e$export$2e2bcd8739ae039 = $f05b1fb586d61e4e$var$formatDistance;

});

parcelRegister("fnY1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3378f9d517ff754$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $b3378f9d517ff754$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $b3378f9d517ff754$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b3378f9d517ff754$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b3378f9d517ff754$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $b3378f9d517ff754$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $b3378f9d517ff754$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $b3378f9d517ff754$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b3378f9d517ff754$export$2e2bcd8739ae039 = $b3378f9d517ff754$var$formatLong;

});

parcelRegister("fx8z1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4f094abae097e51$export$2e2bcd8739ae039);
var $b4f094abae097e51$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $b4f094abae097e51$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b4f094abae097e51$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $b4f094abae097e51$export$2e2bcd8739ae039 = $b4f094abae097e51$var$formatRelative;

});

parcelRegister("eSXEA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad6461c698da6585$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $ad6461c698da6585$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $ad6461c698da6585$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $ad6461c698da6585$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $ad6461c698da6585$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $ad6461c698da6585$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $ad6461c698da6585$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $ad6461c698da6585$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $ad6461c698da6585$var$localize = {
    ordinalNumber: $ad6461c698da6585$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $ad6461c698da6585$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $ad6461c698da6585$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $ad6461c698da6585$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $ad6461c698da6585$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $ad6461c698da6585$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ad6461c698da6585$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ad6461c698da6585$export$2e2bcd8739ae039 = $ad6461c698da6585$var$localize;

});

parcelRegister("ggrPo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd73ba0572b25982$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $bd73ba0572b25982$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $bd73ba0572b25982$var$parseOrdinalNumberPattern = /\d+/i;
var $bd73ba0572b25982$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $bd73ba0572b25982$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $bd73ba0572b25982$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $bd73ba0572b25982$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bd73ba0572b25982$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $bd73ba0572b25982$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $bd73ba0572b25982$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $bd73ba0572b25982$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $bd73ba0572b25982$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $bd73ba0572b25982$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $bd73ba0572b25982$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $bd73ba0572b25982$var$matchOrdinalNumberPattern,
        parsePattern: $bd73ba0572b25982$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $bd73ba0572b25982$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bd73ba0572b25982$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $bd73ba0572b25982$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bd73ba0572b25982$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $bd73ba0572b25982$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bd73ba0572b25982$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $bd73ba0572b25982$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bd73ba0572b25982$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $bd73ba0572b25982$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $bd73ba0572b25982$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $bd73ba0572b25982$export$2e2bcd8739ae039 = $bd73ba0572b25982$var$match;

});


parcelRegister("hRvoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d00fbea9c85ea262$export$2e2bcd8739ae039);

var $6Suxz = parcelRequire("6Suxz");

var $g3qB0 = parcelRequire("g3qB0");

var $jcVFR = parcelRequire("jcVFR");

var $81ZIA = parcelRequire("81ZIA");

var $iBqhZ = parcelRequire("iBqhZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $d00fbea9c85ea262$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $6Suxz.default),
    formatLong: (0, $g3qB0.default),
    formatRelative: (0, $jcVFR.default),
    localize: (0, $81ZIA.default),
    match: (0, $iBqhZ.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d00fbea9c85ea262$export$2e2bcd8739ae039 = $d00fbea9c85ea262$var$locale;

});
parcelRegister("6Suxz", function(module, exports) {
$parcel$export(module.exports, "default", () => $501f79f037d07d98$export$2e2bcd8739ae039);
var $501f79f037d07d98$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $501f79f037d07d98$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $501f79f037d07d98$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $501f79f037d07d98$export$2e2bcd8739ae039 = $501f79f037d07d98$var$formatDistance;

});

parcelRegister("g3qB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb018e88210204cf$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $bb018e88210204cf$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $bb018e88210204cf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $bb018e88210204cf$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $bb018e88210204cf$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $bb018e88210204cf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $bb018e88210204cf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $bb018e88210204cf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $bb018e88210204cf$export$2e2bcd8739ae039 = $bb018e88210204cf$var$formatLong;

});

parcelRegister("jcVFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfbbe02e671d1b42$export$2e2bcd8739ae039);
var $dfbbe02e671d1b42$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $dfbbe02e671d1b42$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $dfbbe02e671d1b42$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $dfbbe02e671d1b42$export$2e2bcd8739ae039 = $dfbbe02e671d1b42$var$formatRelative;

});

parcelRegister("81ZIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d8e4aa45008e4de$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $5d8e4aa45008e4de$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $5d8e4aa45008e4de$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $5d8e4aa45008e4de$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $5d8e4aa45008e4de$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $5d8e4aa45008e4de$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $5d8e4aa45008e4de$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $5d8e4aa45008e4de$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $5d8e4aa45008e4de$var$localize = {
    ordinalNumber: $5d8e4aa45008e4de$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $5d8e4aa45008e4de$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $5d8e4aa45008e4de$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $5d8e4aa45008e4de$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $5d8e4aa45008e4de$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $5d8e4aa45008e4de$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5d8e4aa45008e4de$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5d8e4aa45008e4de$export$2e2bcd8739ae039 = $5d8e4aa45008e4de$var$localize;

});

parcelRegister("iBqhZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8b0132c27a51b59$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $d8b0132c27a51b59$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $d8b0132c27a51b59$var$parseOrdinalNumberPattern = /\d+/i;
var $d8b0132c27a51b59$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $d8b0132c27a51b59$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $d8b0132c27a51b59$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $d8b0132c27a51b59$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d8b0132c27a51b59$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $d8b0132c27a51b59$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $d8b0132c27a51b59$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $d8b0132c27a51b59$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $d8b0132c27a51b59$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $d8b0132c27a51b59$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $d8b0132c27a51b59$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $d8b0132c27a51b59$var$matchOrdinalNumberPattern,
        parsePattern: $d8b0132c27a51b59$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $d8b0132c27a51b59$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8b0132c27a51b59$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $d8b0132c27a51b59$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8b0132c27a51b59$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $d8b0132c27a51b59$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8b0132c27a51b59$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $d8b0132c27a51b59$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8b0132c27a51b59$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $d8b0132c27a51b59$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d8b0132c27a51b59$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d8b0132c27a51b59$export$2e2bcd8739ae039 = $d8b0132c27a51b59$var$match;

});


parcelRegister("bBpzq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8726fc2b570599fd$export$2e2bcd8739ae039);

var $5vfqN = parcelRequire("5vfqN");

var $gcZcE = parcelRequire("gcZcE");

var $cJKIA = parcelRequire("cJKIA");

var $ea2Cs = parcelRequire("ea2Cs");

var $3Ramo = parcelRequire("3Ramo");
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $8726fc2b570599fd$var$locale = {
    code: 'ro',
    formatDistance: (0, $5vfqN.default),
    formatLong: (0, $gcZcE.default),
    formatRelative: (0, $cJKIA.default),
    localize: (0, $ea2Cs.default),
    match: (0, $3Ramo.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8726fc2b570599fd$export$2e2bcd8739ae039 = $8726fc2b570599fd$var$locale;

});
parcelRegister("5vfqN", function(module, exports) {
$parcel$export(module.exports, "default", () => $401bd1566c48e8d2$export$2e2bcd8739ae039);
var $401bd1566c48e8d2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $401bd1566c48e8d2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $401bd1566c48e8d2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $401bd1566c48e8d2$export$2e2bcd8739ae039 = $401bd1566c48e8d2$var$formatDistance;

});

parcelRegister("gcZcE", function(module, exports) {
$parcel$export(module.exports, "default", () => $bccd3dfbc0cf22f4$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $bccd3dfbc0cf22f4$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $bccd3dfbc0cf22f4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $bccd3dfbc0cf22f4$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $bccd3dfbc0cf22f4$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $bccd3dfbc0cf22f4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $bccd3dfbc0cf22f4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $bccd3dfbc0cf22f4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $bccd3dfbc0cf22f4$export$2e2bcd8739ae039 = $bccd3dfbc0cf22f4$var$formatLong;

});

parcelRegister("cJKIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $945ded3a762a0cc2$export$2e2bcd8739ae039);
var $945ded3a762a0cc2$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $945ded3a762a0cc2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $945ded3a762a0cc2$var$formatRelativeLocale[token];
};
var $945ded3a762a0cc2$export$2e2bcd8739ae039 = $945ded3a762a0cc2$var$formatRelative;

});

parcelRegister("ea2Cs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4f40804b8e41309$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $a4f40804b8e41309$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $a4f40804b8e41309$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $a4f40804b8e41309$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $a4f40804b8e41309$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $a4f40804b8e41309$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $a4f40804b8e41309$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $a4f40804b8e41309$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $a4f40804b8e41309$var$localize = {
    ordinalNumber: $a4f40804b8e41309$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $a4f40804b8e41309$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $a4f40804b8e41309$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $a4f40804b8e41309$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $a4f40804b8e41309$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $a4f40804b8e41309$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a4f40804b8e41309$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a4f40804b8e41309$export$2e2bcd8739ae039 = $a4f40804b8e41309$var$localize;

});

parcelRegister("3Ramo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cee5ba1c907339a$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $2cee5ba1c907339a$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $2cee5ba1c907339a$var$parseOrdinalNumberPattern = /\d+/i;
var $2cee5ba1c907339a$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $2cee5ba1c907339a$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $2cee5ba1c907339a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $2cee5ba1c907339a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2cee5ba1c907339a$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $2cee5ba1c907339a$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2cee5ba1c907339a$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $2cee5ba1c907339a$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $2cee5ba1c907339a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $2cee5ba1c907339a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $2cee5ba1c907339a$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $2cee5ba1c907339a$var$matchOrdinalNumberPattern,
        parsePattern: $2cee5ba1c907339a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $2cee5ba1c907339a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2cee5ba1c907339a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $2cee5ba1c907339a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2cee5ba1c907339a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $2cee5ba1c907339a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2cee5ba1c907339a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $2cee5ba1c907339a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2cee5ba1c907339a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $2cee5ba1c907339a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2cee5ba1c907339a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2cee5ba1c907339a$export$2e2bcd8739ae039 = $2cee5ba1c907339a$var$match;

});


parcelRegister("icVyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d415fdf47d868863$export$2e2bcd8739ae039);

var $gJf52 = parcelRequire("gJf52");

var $iggir = parcelRequire("iggir");

var $eI1GL = parcelRequire("eI1GL");

var $giLjw = parcelRequire("giLjw");

var $hPcFm = parcelRequire("hPcFm");
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $d415fdf47d868863$var$locale = {
    code: 'ru',
    formatDistance: (0, $gJf52.default),
    formatLong: (0, $iggir.default),
    formatRelative: (0, $eI1GL.default),
    localize: (0, $giLjw.default),
    match: (0, $hPcFm.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $d415fdf47d868863$export$2e2bcd8739ae039 = $d415fdf47d868863$var$locale;

});
parcelRegister("gJf52", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2dc8bf4df4a4877$export$2e2bcd8739ae039);
function $c2dc8bf4df4a4877$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $c2dc8bf4df4a4877$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $c2dc8bf4df4a4877$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $c2dc8bf4df4a4877$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $c2dc8bf4df4a4877$var$declension(scheme.past, count);
                else return $c2dc8bf4df4a4877$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $c2dc8bf4df4a4877$var$declension(scheme.regular, count);
    };
}
var $c2dc8bf4df4a4877$var$formatDistanceLocale = {
    lessThanXSeconds: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $c2dc8bf4df4a4877$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $c2dc8bf4df4a4877$var$formatDistance = function formatDistance(token, count, options) {
    return $c2dc8bf4df4a4877$var$formatDistanceLocale[token](count, options);
};
var $c2dc8bf4df4a4877$export$2e2bcd8739ae039 = $c2dc8bf4df4a4877$var$formatDistance;

});

parcelRegister("iggir", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4b65cc21b966245$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $d4b65cc21b966245$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $d4b65cc21b966245$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $d4b65cc21b966245$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $d4b65cc21b966245$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $d4b65cc21b966245$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $d4b65cc21b966245$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $d4b65cc21b966245$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $d4b65cc21b966245$export$2e2bcd8739ae039 = $d4b65cc21b966245$var$formatLong;

});

parcelRegister("eI1GL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab567c1d6877e66a$export$2e2bcd8739ae039);

var $2vhsi = parcelRequire("2vhsi");
var $ab567c1d6877e66a$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $ab567c1d6877e66a$var$_lastWeek(day) {
    var weekday = $ab567c1d6877e66a$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $ab567c1d6877e66a$var$thisWeek(day) {
    var weekday = $ab567c1d6877e66a$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $ab567c1d6877e66a$var$_nextWeek(day) {
    var weekday = $ab567c1d6877e66a$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $ab567c1d6877e66a$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $ab567c1d6877e66a$var$thisWeek(day);
        else return $ab567c1d6877e66a$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $ab567c1d6877e66a$var$thisWeek(day);
        else return $ab567c1d6877e66a$var$_nextWeek(day);
    },
    other: 'P'
};
var $ab567c1d6877e66a$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $ab567c1d6877e66a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $ab567c1d6877e66a$export$2e2bcd8739ae039 = $ab567c1d6877e66a$var$formatRelative;

});

parcelRegister("giLjw", function(module, exports) {
$parcel$export(module.exports, "default", () => $bde30753965921b9$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $bde30753965921b9$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $bde30753965921b9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $bde30753965921b9$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $bde30753965921b9$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $bde30753965921b9$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $bde30753965921b9$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $bde30753965921b9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $bde30753965921b9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $bde30753965921b9$var$localize = {
    ordinalNumber: $bde30753965921b9$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $bde30753965921b9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $bde30753965921b9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $bde30753965921b9$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $bde30753965921b9$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $bde30753965921b9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $bde30753965921b9$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $bde30753965921b9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bde30753965921b9$export$2e2bcd8739ae039 = $bde30753965921b9$var$localize;

});

parcelRegister("hPcFm", function(module, exports) {
$parcel$export(module.exports, "default", () => $03594e8daf3df847$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $03594e8daf3df847$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $03594e8daf3df847$var$parseOrdinalNumberPattern = /\d+/i;
var $03594e8daf3df847$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $03594e8daf3df847$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $03594e8daf3df847$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $03594e8daf3df847$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $03594e8daf3df847$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $03594e8daf3df847$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $03594e8daf3df847$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $03594e8daf3df847$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $03594e8daf3df847$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $03594e8daf3df847$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $03594e8daf3df847$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $03594e8daf3df847$var$matchOrdinalNumberPattern,
        parsePattern: $03594e8daf3df847$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $03594e8daf3df847$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $03594e8daf3df847$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $03594e8daf3df847$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $03594e8daf3df847$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $03594e8daf3df847$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $03594e8daf3df847$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $03594e8daf3df847$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $03594e8daf3df847$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $03594e8daf3df847$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $03594e8daf3df847$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $03594e8daf3df847$export$2e2bcd8739ae039 = $03594e8daf3df847$var$match;

});


parcelRegister("2R1DF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2141cd757128dc9a$export$2e2bcd8739ae039);

var $ejHbH = parcelRequire("ejHbH");

var $fEOkf = parcelRequire("fEOkf");

var $1tKVO = parcelRequire("1tKVO");

var $amEGq = parcelRequire("amEGq");

var $6j6hu = parcelRequire("6j6hu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $2141cd757128dc9a$var$locale = {
    code: 'sk',
    formatDistance: (0, $ejHbH.default),
    formatLong: (0, $fEOkf.default),
    formatRelative: (0, $1tKVO.default),
    localize: (0, $amEGq.default),
    match: (0, $6j6hu.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2141cd757128dc9a$export$2e2bcd8739ae039 = $2141cd757128dc9a$var$locale;

});
parcelRegister("ejHbH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6c4573616a30a13$export$2e2bcd8739ae039);
function $a6c4573616a30a13$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $a6c4573616a30a13$var$declension(scheme, count, time) {
    var group = $a6c4573616a30a13$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $a6c4573616a30a13$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $a6c4573616a30a13$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $a6c4573616a30a13$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $a6c4573616a30a13$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $a6c4573616a30a13$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $a6c4573616a30a13$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $a6c4573616a30a13$var$extractPreposition(token) || '';
    var key = $a6c4573616a30a13$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $a6c4573616a30a13$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $a6c4573616a30a13$var$prefixPreposition(preposition) + $a6c4573616a30a13$var$suffixPreposition(preposition) + $a6c4573616a30a13$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $a6c4573616a30a13$var$prefixPreposition(preposition) + 'o ' + $a6c4573616a30a13$var$suffixPreposition(preposition) + $a6c4573616a30a13$var$declension(scheme, count, 'future');
    else return $a6c4573616a30a13$var$prefixPreposition(preposition) + 'pred ' + $a6c4573616a30a13$var$suffixPreposition(preposition) + $a6c4573616a30a13$var$declension(scheme, count, 'past');
};
var $a6c4573616a30a13$export$2e2bcd8739ae039 = $a6c4573616a30a13$var$formatDistance;

});

parcelRegister("fEOkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b661a113bbe045d2$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $b661a113bbe045d2$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $b661a113bbe045d2$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $b661a113bbe045d2$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $b661a113bbe045d2$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $b661a113bbe045d2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $b661a113bbe045d2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $b661a113bbe045d2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b661a113bbe045d2$export$2e2bcd8739ae039 = $b661a113bbe045d2$var$formatLong;

});

parcelRegister("1tKVO", function(module, exports) {
$parcel$export(module.exports, "default", () => $113ce781bc55cb09$export$2e2bcd8739ae039);

var $2vhsi = parcelRequire("2vhsi");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $113ce781bc55cb09$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $113ce781bc55cb09$var$_lastWeek(day) {
    var weekday = $113ce781bc55cb09$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $113ce781bc55cb09$var$thisWeek(day) {
    var weekday = $113ce781bc55cb09$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $113ce781bc55cb09$var$_nextWeek(day) {
    var weekday = $113ce781bc55cb09$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $113ce781bc55cb09$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $113ce781bc55cb09$var$thisWeek(day);
        else return $113ce781bc55cb09$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2vhsi.default)(date, baseDate, options)) return $113ce781bc55cb09$var$thisWeek(day);
        else return $113ce781bc55cb09$var$_nextWeek(day);
    },
    other: 'P'
};
var $113ce781bc55cb09$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $113ce781bc55cb09$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $113ce781bc55cb09$export$2e2bcd8739ae039 = $113ce781bc55cb09$var$formatRelative;

});

parcelRegister("amEGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $78bb844f1e6a2b19$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $78bb844f1e6a2b19$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $78bb844f1e6a2b19$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $78bb844f1e6a2b19$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $78bb844f1e6a2b19$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $78bb844f1e6a2b19$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $78bb844f1e6a2b19$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $78bb844f1e6a2b19$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $78bb844f1e6a2b19$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $78bb844f1e6a2b19$var$localize = {
    ordinalNumber: $78bb844f1e6a2b19$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $78bb844f1e6a2b19$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $78bb844f1e6a2b19$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $78bb844f1e6a2b19$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $78bb844f1e6a2b19$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $78bb844f1e6a2b19$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $78bb844f1e6a2b19$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $78bb844f1e6a2b19$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $78bb844f1e6a2b19$export$2e2bcd8739ae039 = $78bb844f1e6a2b19$var$localize;

});

parcelRegister("6j6hu", function(module, exports) {
$parcel$export(module.exports, "default", () => $497963b6096f5fb2$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $497963b6096f5fb2$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $497963b6096f5fb2$var$parseOrdinalNumberPattern = /\d+/i;
var $497963b6096f5fb2$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $497963b6096f5fb2$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $497963b6096f5fb2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $497963b6096f5fb2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $497963b6096f5fb2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $497963b6096f5fb2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $497963b6096f5fb2$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $497963b6096f5fb2$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $497963b6096f5fb2$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $497963b6096f5fb2$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $497963b6096f5fb2$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $497963b6096f5fb2$var$matchOrdinalNumberPattern,
        parsePattern: $497963b6096f5fb2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $497963b6096f5fb2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $497963b6096f5fb2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $497963b6096f5fb2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $497963b6096f5fb2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $497963b6096f5fb2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $497963b6096f5fb2$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $497963b6096f5fb2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $497963b6096f5fb2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $497963b6096f5fb2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $497963b6096f5fb2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $497963b6096f5fb2$export$2e2bcd8739ae039 = $497963b6096f5fb2$var$match;

});


parcelRegister("aSMzB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec4a0251d5ddbce$export$2e2bcd8739ae039);

var $9DP0X = parcelRequire("9DP0X");

var $dPD1j = parcelRequire("dPD1j");

var $03vrc = parcelRequire("03vrc");

var $1F98F = parcelRequire("1F98F");

var $9GsFP = parcelRequire("9GsFP");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $7ec4a0251d5ddbce$var$locale = {
    code: 'sv',
    formatDistance: (0, $9DP0X.default),
    formatLong: (0, $dPD1j.default),
    formatRelative: (0, $03vrc.default),
    localize: (0, $1F98F.default),
    match: (0, $9GsFP.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7ec4a0251d5ddbce$export$2e2bcd8739ae039 = $7ec4a0251d5ddbce$var$locale;

});
parcelRegister("9DP0X", function(module, exports) {
$parcel$export(module.exports, "default", () => $704f53fa4dc335e4$export$2e2bcd8739ae039);
var $704f53fa4dc335e4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $704f53fa4dc335e4$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $704f53fa4dc335e4$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $704f53fa4dc335e4$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $704f53fa4dc335e4$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $704f53fa4dc335e4$export$2e2bcd8739ae039 = $704f53fa4dc335e4$var$formatDistance;

});

parcelRegister("dPD1j", function(module, exports) {
$parcel$export(module.exports, "default", () => $a11e4e5db03f2eea$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $a11e4e5db03f2eea$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $a11e4e5db03f2eea$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a11e4e5db03f2eea$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $a11e4e5db03f2eea$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $a11e4e5db03f2eea$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $a11e4e5db03f2eea$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $a11e4e5db03f2eea$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a11e4e5db03f2eea$export$2e2bcd8739ae039 = $a11e4e5db03f2eea$var$formatLong;

});

parcelRegister("03vrc", function(module, exports) {
$parcel$export(module.exports, "default", () => $00a8aacf7d18cc11$export$2e2bcd8739ae039);
var $00a8aacf7d18cc11$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $00a8aacf7d18cc11$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $00a8aacf7d18cc11$var$formatRelativeLocale[token];
};
var $00a8aacf7d18cc11$export$2e2bcd8739ae039 = $00a8aacf7d18cc11$var$formatRelative;

});

parcelRegister("1F98F", function(module, exports) {
$parcel$export(module.exports, "default", () => $1360b58a95b868b6$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $1360b58a95b868b6$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $1360b58a95b868b6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $1360b58a95b868b6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $1360b58a95b868b6$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $1360b58a95b868b6$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $1360b58a95b868b6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $1360b58a95b868b6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $1360b58a95b868b6$var$localize = {
    ordinalNumber: $1360b58a95b868b6$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $1360b58a95b868b6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $1360b58a95b868b6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $1360b58a95b868b6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $1360b58a95b868b6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $1360b58a95b868b6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1360b58a95b868b6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1360b58a95b868b6$export$2e2bcd8739ae039 = $1360b58a95b868b6$var$localize;

});

parcelRegister("9GsFP", function(module, exports) {
$parcel$export(module.exports, "default", () => $70ce4750b29bea8b$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $70ce4750b29bea8b$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $70ce4750b29bea8b$var$parseOrdinalNumberPattern = /\d+/i;
var $70ce4750b29bea8b$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $70ce4750b29bea8b$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $70ce4750b29bea8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $70ce4750b29bea8b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $70ce4750b29bea8b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $70ce4750b29bea8b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $70ce4750b29bea8b$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $70ce4750b29bea8b$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $70ce4750b29bea8b$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $70ce4750b29bea8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $70ce4750b29bea8b$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $70ce4750b29bea8b$var$matchOrdinalNumberPattern,
        parsePattern: $70ce4750b29bea8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $70ce4750b29bea8b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70ce4750b29bea8b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $70ce4750b29bea8b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70ce4750b29bea8b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $70ce4750b29bea8b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70ce4750b29bea8b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $70ce4750b29bea8b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70ce4750b29bea8b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $70ce4750b29bea8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $70ce4750b29bea8b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $70ce4750b29bea8b$export$2e2bcd8739ae039 = $70ce4750b29bea8b$var$match;

});


parcelRegister("gFI8Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $c232b7495858dbd6$export$2e2bcd8739ae039);

var $2z8nD = parcelRequire("2z8nD");

var $1Uy4T = parcelRequire("1Uy4T");

var $EvrRL = parcelRequire("EvrRL");

var $f5Dod = parcelRequire("f5Dod");

var $dZxId = parcelRequire("dZxId");
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $c232b7495858dbd6$var$locale = {
    code: 'tr',
    formatDistance: (0, $2z8nD.default),
    formatLong: (0, $1Uy4T.default),
    formatRelative: (0, $EvrRL.default),
    localize: (0, $f5Dod.default),
    match: (0, $dZxId.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c232b7495858dbd6$export$2e2bcd8739ae039 = $c232b7495858dbd6$var$locale;

});
parcelRegister("2z8nD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1de559ce60d90e10$export$2e2bcd8739ae039);
var $1de559ce60d90e10$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $1de559ce60d90e10$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1de559ce60d90e10$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $1de559ce60d90e10$export$2e2bcd8739ae039 = $1de559ce60d90e10$var$formatDistance;

});

parcelRegister("1Uy4T", function(module, exports) {
$parcel$export(module.exports, "default", () => $16457494e1ce2b7c$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $16457494e1ce2b7c$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $16457494e1ce2b7c$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $16457494e1ce2b7c$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $16457494e1ce2b7c$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $16457494e1ce2b7c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $16457494e1ce2b7c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $16457494e1ce2b7c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $16457494e1ce2b7c$export$2e2bcd8739ae039 = $16457494e1ce2b7c$var$formatLong;

});

parcelRegister("EvrRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $079c218cad2d0121$export$2e2bcd8739ae039);
var $079c218cad2d0121$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $079c218cad2d0121$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $079c218cad2d0121$var$formatRelativeLocale[token];
};
var $079c218cad2d0121$export$2e2bcd8739ae039 = $079c218cad2d0121$var$formatRelative;

});

parcelRegister("f5Dod", function(module, exports) {
$parcel$export(module.exports, "default", () => $afc5e09d3629f956$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $afc5e09d3629f956$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $afc5e09d3629f956$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $afc5e09d3629f956$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $afc5e09d3629f956$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $afc5e09d3629f956$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $afc5e09d3629f956$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $afc5e09d3629f956$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $afc5e09d3629f956$var$localize = {
    ordinalNumber: $afc5e09d3629f956$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $afc5e09d3629f956$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $afc5e09d3629f956$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $afc5e09d3629f956$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $afc5e09d3629f956$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $afc5e09d3629f956$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $afc5e09d3629f956$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $afc5e09d3629f956$export$2e2bcd8739ae039 = $afc5e09d3629f956$var$localize;

});

parcelRegister("dZxId", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2fb1f6022feab01$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $a2fb1f6022feab01$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $a2fb1f6022feab01$var$parseOrdinalNumberPattern = /\d+/i;
var $a2fb1f6022feab01$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $a2fb1f6022feab01$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $a2fb1f6022feab01$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $a2fb1f6022feab01$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $a2fb1f6022feab01$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $a2fb1f6022feab01$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $a2fb1f6022feab01$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $a2fb1f6022feab01$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $a2fb1f6022feab01$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $a2fb1f6022feab01$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $a2fb1f6022feab01$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $a2fb1f6022feab01$var$matchOrdinalNumberPattern,
        parsePattern: $a2fb1f6022feab01$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $a2fb1f6022feab01$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2fb1f6022feab01$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $a2fb1f6022feab01$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2fb1f6022feab01$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $a2fb1f6022feab01$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2fb1f6022feab01$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $a2fb1f6022feab01$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2fb1f6022feab01$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $a2fb1f6022feab01$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a2fb1f6022feab01$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a2fb1f6022feab01$export$2e2bcd8739ae039 = $a2fb1f6022feab01$var$match;

});


parcelRegister("693Jn", function(module, exports) {
$parcel$export(module.exports, "default", () => $47967a33d51e0b3a$export$2e2bcd8739ae039);

var $cpkYr = parcelRequire("cpkYr");

var $c5Y4C = parcelRequire("c5Y4C");

var $8t04v = parcelRequire("8t04v");

var $deKdh = parcelRequire("deKdh");

var $17CnY = parcelRequire("17CnY");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $47967a33d51e0b3a$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $cpkYr.default),
    formatLong: (0, $c5Y4C.default),
    formatRelative: (0, $8t04v.default),
    localize: (0, $deKdh.default),
    match: (0, $17CnY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $47967a33d51e0b3a$export$2e2bcd8739ae039 = $47967a33d51e0b3a$var$locale;

});
parcelRegister("cpkYr", function(module, exports) {
$parcel$export(module.exports, "default", () => $908816d01c55397d$export$2e2bcd8739ae039);
var $908816d01c55397d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $908816d01c55397d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $908816d01c55397d$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $908816d01c55397d$export$2e2bcd8739ae039 = $908816d01c55397d$var$formatDistance;

});

parcelRegister("c5Y4C", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce48d085a3a0ef2$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $8ce48d085a3a0ef2$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $8ce48d085a3a0ef2$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $8ce48d085a3a0ef2$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $8ce48d085a3a0ef2$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $8ce48d085a3a0ef2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $8ce48d085a3a0ef2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $8ce48d085a3a0ef2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8ce48d085a3a0ef2$export$2e2bcd8739ae039 = $8ce48d085a3a0ef2$var$formatLong;

});

parcelRegister("8t04v", function(module, exports) {
$parcel$export(module.exports, "default", () => $62a116643c71ef7c$export$2e2bcd8739ae039);

var $2vhsi = parcelRequire("2vhsi");
function $62a116643c71ef7c$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $2vhsi.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $62a116643c71ef7c$var$formatRelativeLocale = {
    lastWeek: $62a116643c71ef7c$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $62a116643c71ef7c$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $62a116643c71ef7c$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $62a116643c71ef7c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $62a116643c71ef7c$export$2e2bcd8739ae039 = $62a116643c71ef7c$var$formatRelative;

});

parcelRegister("deKdh", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a306e1eec973c48$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $9a306e1eec973c48$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $9a306e1eec973c48$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $9a306e1eec973c48$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $9a306e1eec973c48$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $9a306e1eec973c48$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $9a306e1eec973c48$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $9a306e1eec973c48$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $9a306e1eec973c48$var$localize = {
    ordinalNumber: $9a306e1eec973c48$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $9a306e1eec973c48$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $9a306e1eec973c48$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $9a306e1eec973c48$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $9a306e1eec973c48$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $9a306e1eec973c48$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9a306e1eec973c48$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9a306e1eec973c48$export$2e2bcd8739ae039 = $9a306e1eec973c48$var$localize;

});

parcelRegister("17CnY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d14387d976e8fb9$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $0d14387d976e8fb9$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $0d14387d976e8fb9$var$parseOrdinalNumberPattern = /\d+/i;
var $0d14387d976e8fb9$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $0d14387d976e8fb9$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $0d14387d976e8fb9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $0d14387d976e8fb9$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $0d14387d976e8fb9$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $0d14387d976e8fb9$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $0d14387d976e8fb9$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $0d14387d976e8fb9$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $0d14387d976e8fb9$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $0d14387d976e8fb9$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $0d14387d976e8fb9$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $0d14387d976e8fb9$var$matchOrdinalNumberPattern,
        parsePattern: $0d14387d976e8fb9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $0d14387d976e8fb9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0d14387d976e8fb9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $0d14387d976e8fb9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0d14387d976e8fb9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $0d14387d976e8fb9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0d14387d976e8fb9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $0d14387d976e8fb9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0d14387d976e8fb9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $0d14387d976e8fb9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0d14387d976e8fb9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0d14387d976e8fb9$export$2e2bcd8739ae039 = $0d14387d976e8fb9$var$match;

});


parcelRegister("dcW3Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $99d96f0f1946a1a4$export$2e2bcd8739ae039);

var $dBxRx = parcelRequire("dBxRx");

var $aPUg0 = parcelRequire("aPUg0");

var $guIu5 = parcelRequire("guIu5");

var $2sQVz = parcelRequire("2sQVz");

var $e2m6z = parcelRequire("e2m6z");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $99d96f0f1946a1a4$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $dBxRx.default),
    formatLong: (0, $aPUg0.default),
    formatRelative: (0, $guIu5.default),
    localize: (0, $2sQVz.default),
    match: (0, $e2m6z.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $99d96f0f1946a1a4$export$2e2bcd8739ae039 = $99d96f0f1946a1a4$var$locale;

});
parcelRegister("dBxRx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e78ff78d265c4b2$export$2e2bcd8739ae039);
var $9e78ff78d265c4b2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $9e78ff78d265c4b2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9e78ff78d265c4b2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $9e78ff78d265c4b2$export$2e2bcd8739ae039 = $9e78ff78d265c4b2$var$formatDistance;

});

parcelRegister("aPUg0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e3a4e533246241c$export$2e2bcd8739ae039);

var $4ESZQ = parcelRequire("4ESZQ");
var $7e3a4e533246241c$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $7e3a4e533246241c$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $7e3a4e533246241c$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7e3a4e533246241c$var$formatLong = {
    date: (0, $4ESZQ.default)({
        formats: $7e3a4e533246241c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4ESZQ.default)({
        formats: $7e3a4e533246241c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4ESZQ.default)({
        formats: $7e3a4e533246241c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7e3a4e533246241c$export$2e2bcd8739ae039 = $7e3a4e533246241c$var$formatLong;

});

parcelRegister("guIu5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c021f454d405a26f$export$2e2bcd8739ae039);
var $c021f454d405a26f$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $c021f454d405a26f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c021f454d405a26f$var$formatRelativeLocale[token];
};
var $c021f454d405a26f$export$2e2bcd8739ae039 = $c021f454d405a26f$var$formatRelative;

});

parcelRegister("2sQVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cb7409f7d3f7622$export$2e2bcd8739ae039);

var $4JSD1 = parcelRequire("4JSD1");
var $1cb7409f7d3f7622$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $1cb7409f7d3f7622$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $1cb7409f7d3f7622$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $1cb7409f7d3f7622$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $1cb7409f7d3f7622$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $1cb7409f7d3f7622$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $1cb7409f7d3f7622$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $1cb7409f7d3f7622$var$localize = {
    ordinalNumber: $1cb7409f7d3f7622$var$ordinalNumber,
    era: (0, $4JSD1.default)({
        values: $1cb7409f7d3f7622$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4JSD1.default)({
        values: $1cb7409f7d3f7622$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4JSD1.default)({
        values: $1cb7409f7d3f7622$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4JSD1.default)({
        values: $1cb7409f7d3f7622$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4JSD1.default)({
        values: $1cb7409f7d3f7622$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1cb7409f7d3f7622$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1cb7409f7d3f7622$export$2e2bcd8739ae039 = $1cb7409f7d3f7622$var$localize;

});

parcelRegister("e2m6z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a38266320483ccd4$export$2e2bcd8739ae039);

var $9R4Zi = parcelRequire("9R4Zi");

var $lXxnR = parcelRequire("lXxnR");
var $a38266320483ccd4$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $a38266320483ccd4$var$parseOrdinalNumberPattern = /\d+/i;
var $a38266320483ccd4$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $a38266320483ccd4$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $a38266320483ccd4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $a38266320483ccd4$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $a38266320483ccd4$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $a38266320483ccd4$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $a38266320483ccd4$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $a38266320483ccd4$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $a38266320483ccd4$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $a38266320483ccd4$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $a38266320483ccd4$var$match = {
    ordinalNumber: (0, $lXxnR.default)({
        matchPattern: $a38266320483ccd4$var$matchOrdinalNumberPattern,
        parsePattern: $a38266320483ccd4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9R4Zi.default)({
        matchPatterns: $a38266320483ccd4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a38266320483ccd4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9R4Zi.default)({
        matchPatterns: $a38266320483ccd4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a38266320483ccd4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9R4Zi.default)({
        matchPatterns: $a38266320483ccd4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a38266320483ccd4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9R4Zi.default)({
        matchPatterns: $a38266320483ccd4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a38266320483ccd4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9R4Zi.default)({
        matchPatterns: $a38266320483ccd4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a38266320483ccd4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a38266320483ccd4$export$2e2bcd8739ae039 = $a38266320483ccd4$var$match;

});


parcelRegister("1KeoX", function(module, exports) {

var $kxesc = parcelRequire("kxesc");
/** Used to compose bitmasks for cloning. */ var $1455422b45ac2ad4$var$CLONE_DEEP_FLAG = 1, $1455422b45ac2ad4$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $1455422b45ac2ad4$var$cloneDeep(value) {
    return $kxesc(value, $1455422b45ac2ad4$var$CLONE_DEEP_FLAG | $1455422b45ac2ad4$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $1455422b45ac2ad4$var$cloneDeep;

});
parcelRegister("kxesc", function(module, exports) {

var $iIHTo = parcelRequire("iIHTo");

var $h6Xza = parcelRequire("h6Xza");

var $8mv3w = parcelRequire("8mv3w");

var $fvRFV = parcelRequire("fvRFV");

var $f6wrc = parcelRequire("f6wrc");

var $3dwVm = parcelRequire("3dwVm");

var $3Zjeo = parcelRequire("3Zjeo");

var $jqoUk = parcelRequire("jqoUk");

var $fz9Ug = parcelRequire("fz9Ug");

var $1bLAB = parcelRequire("1bLAB");

var $94agL = parcelRequire("94agL");

var $iPK9x = parcelRequire("iPK9x");

var $1YsrY = parcelRequire("1YsrY");

var $iasne = parcelRequire("iasne");

var $3Y5C2 = parcelRequire("3Y5C2");

var $11H9d = parcelRequire("11H9d");

var $dAakG = parcelRequire("dAakG");

var $kEj1q = parcelRequire("kEj1q");

var $2vblS = parcelRequire("2vblS");

var $6ERIi = parcelRequire("6ERIi");

var $fyIDO = parcelRequire("fyIDO");

var $dKfwW = parcelRequire("dKfwW");
/** Used to compose bitmasks for cloning. */ var $ef3219ee3017fd11$var$CLONE_DEEP_FLAG = 1, $ef3219ee3017fd11$var$CLONE_FLAT_FLAG = 2, $ef3219ee3017fd11$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ef3219ee3017fd11$var$argsTag = '[object Arguments]', $ef3219ee3017fd11$var$arrayTag = '[object Array]', $ef3219ee3017fd11$var$boolTag = '[object Boolean]', $ef3219ee3017fd11$var$dateTag = '[object Date]', $ef3219ee3017fd11$var$errorTag = '[object Error]', $ef3219ee3017fd11$var$funcTag = '[object Function]', $ef3219ee3017fd11$var$genTag = '[object GeneratorFunction]', $ef3219ee3017fd11$var$mapTag = '[object Map]', $ef3219ee3017fd11$var$numberTag = '[object Number]', $ef3219ee3017fd11$var$objectTag = '[object Object]', $ef3219ee3017fd11$var$regexpTag = '[object RegExp]', $ef3219ee3017fd11$var$setTag = '[object Set]', $ef3219ee3017fd11$var$stringTag = '[object String]', $ef3219ee3017fd11$var$symbolTag = '[object Symbol]', $ef3219ee3017fd11$var$weakMapTag = '[object WeakMap]';
var $ef3219ee3017fd11$var$arrayBufferTag = '[object ArrayBuffer]', $ef3219ee3017fd11$var$dataViewTag = '[object DataView]', $ef3219ee3017fd11$var$float32Tag = '[object Float32Array]', $ef3219ee3017fd11$var$float64Tag = '[object Float64Array]', $ef3219ee3017fd11$var$int8Tag = '[object Int8Array]', $ef3219ee3017fd11$var$int16Tag = '[object Int16Array]', $ef3219ee3017fd11$var$int32Tag = '[object Int32Array]', $ef3219ee3017fd11$var$uint8Tag = '[object Uint8Array]', $ef3219ee3017fd11$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ef3219ee3017fd11$var$uint16Tag = '[object Uint16Array]', $ef3219ee3017fd11$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ef3219ee3017fd11$var$cloneableTags = {};
$ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$argsTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$arrayTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$arrayBufferTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$dataViewTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$boolTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$dateTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$float32Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$float64Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$int8Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$int16Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$int32Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$mapTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$numberTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$objectTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$regexpTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$setTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$stringTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$symbolTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$uint8Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$uint8ClampedTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$uint16Tag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$uint32Tag] = true;
$ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$errorTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$funcTag] = $ef3219ee3017fd11$var$cloneableTags[$ef3219ee3017fd11$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ef3219ee3017fd11$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ef3219ee3017fd11$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ef3219ee3017fd11$var$CLONE_FLAT_FLAG, isFull = bitmask & $ef3219ee3017fd11$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$2vblS(value)) return value;
    var isArr = $11H9d(value);
    if (isArr) {
        result = $1YsrY(value);
        if (!isDeep) return $3Zjeo(value, result);
    } else {
        var tag = $iPK9x(value), isFunc = tag == $ef3219ee3017fd11$var$funcTag || tag == $ef3219ee3017fd11$var$genTag;
        if ($dAakG(value)) return $3dwVm(value, isDeep);
        if (tag == $ef3219ee3017fd11$var$objectTag || tag == $ef3219ee3017fd11$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $3Y5C2(value);
            if (!isDeep) return isFlat ? $fz9Ug(value, $f6wrc(result, value)) : $jqoUk(value, $fvRFV(result, value));
        } else {
            if (!$ef3219ee3017fd11$var$cloneableTags[tag]) return object ? value : {};
            result = $iasne(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $iIHTo);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6ERIi(value)) value.forEach(function(subValue) {
        result.add($ef3219ee3017fd11$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($kEj1q(value)) value.forEach(function(subValue, key) {
        result.set(key, $ef3219ee3017fd11$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $94agL : $1bLAB : isFlat ? $dKfwW : $fyIDO;
    var props = isArr ? undefined : keysFunc(value);
    $h6Xza(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $8mv3w(result, key, $ef3219ee3017fd11$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ef3219ee3017fd11$var$baseClone;

});
parcelRegister("h6Xza", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $c75133d367bdbb40$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $c75133d367bdbb40$var$arrayEach;

});

parcelRegister("fvRFV", function(module, exports) {

var $cFg8N = parcelRequire("cFg8N");

var $fyIDO = parcelRequire("fyIDO");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b4b3630aad49ddee$var$baseAssign(object, source) {
    return object && $cFg8N(source, $fyIDO(source), object);
}
module.exports = $b4b3630aad49ddee$var$baseAssign;

});

parcelRegister("f6wrc", function(module, exports) {

var $cFg8N = parcelRequire("cFg8N");

var $dKfwW = parcelRequire("dKfwW");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $aff09404bb1b5563$var$baseAssignIn(object, source) {
    return object && $cFg8N(source, $dKfwW(source), object);
}
module.exports = $aff09404bb1b5563$var$baseAssignIn;

});

parcelRegister("jqoUk", function(module, exports) {

var $cFg8N = parcelRequire("cFg8N");

var $bdv36 = parcelRequire("bdv36");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e243c42339d86fc7$var$copySymbols(source, object) {
    return $cFg8N(source, $bdv36(source), object);
}
module.exports = $e243c42339d86fc7$var$copySymbols;

});

parcelRegister("fz9Ug", function(module, exports) {

var $cFg8N = parcelRequire("cFg8N");

var $3qrL6 = parcelRequire("3qrL6");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b551cf21e5b8d559$var$copySymbolsIn(source, object) {
    return $cFg8N(source, $3qrL6(source), object);
}
module.exports = $b551cf21e5b8d559$var$copySymbolsIn;

});

parcelRegister("1YsrY", function(module, exports) {
/** Used for built-in method references. */ var $170176aa1cb2a0a1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $170176aa1cb2a0a1$var$hasOwnProperty = $170176aa1cb2a0a1$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $170176aa1cb2a0a1$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $170176aa1cb2a0a1$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $170176aa1cb2a0a1$var$initCloneArray;

});

parcelRegister("iasne", function(module, exports) {

var $8LtMv = parcelRequire("8LtMv");

var $cdpQB = parcelRequire("cdpQB");

var $1JTkQ = parcelRequire("1JTkQ");

var $daLgt = parcelRequire("daLgt");

var $3ltG5 = parcelRequire("3ltG5");
/** `Object#toString` result references. */ var $d39f2b91b1cf57e1$var$boolTag = '[object Boolean]', $d39f2b91b1cf57e1$var$dateTag = '[object Date]', $d39f2b91b1cf57e1$var$mapTag = '[object Map]', $d39f2b91b1cf57e1$var$numberTag = '[object Number]', $d39f2b91b1cf57e1$var$regexpTag = '[object RegExp]', $d39f2b91b1cf57e1$var$setTag = '[object Set]', $d39f2b91b1cf57e1$var$stringTag = '[object String]', $d39f2b91b1cf57e1$var$symbolTag = '[object Symbol]';
var $d39f2b91b1cf57e1$var$arrayBufferTag = '[object ArrayBuffer]', $d39f2b91b1cf57e1$var$dataViewTag = '[object DataView]', $d39f2b91b1cf57e1$var$float32Tag = '[object Float32Array]', $d39f2b91b1cf57e1$var$float64Tag = '[object Float64Array]', $d39f2b91b1cf57e1$var$int8Tag = '[object Int8Array]', $d39f2b91b1cf57e1$var$int16Tag = '[object Int16Array]', $d39f2b91b1cf57e1$var$int32Tag = '[object Int32Array]', $d39f2b91b1cf57e1$var$uint8Tag = '[object Uint8Array]', $d39f2b91b1cf57e1$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d39f2b91b1cf57e1$var$uint16Tag = '[object Uint16Array]', $d39f2b91b1cf57e1$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d39f2b91b1cf57e1$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d39f2b91b1cf57e1$var$arrayBufferTag:
            return $8LtMv(object);
        case $d39f2b91b1cf57e1$var$boolTag:
        case $d39f2b91b1cf57e1$var$dateTag:
            return new Ctor(+object);
        case $d39f2b91b1cf57e1$var$dataViewTag:
            return $cdpQB(object, isDeep);
        case $d39f2b91b1cf57e1$var$float32Tag:
        case $d39f2b91b1cf57e1$var$float64Tag:
        case $d39f2b91b1cf57e1$var$int8Tag:
        case $d39f2b91b1cf57e1$var$int16Tag:
        case $d39f2b91b1cf57e1$var$int32Tag:
        case $d39f2b91b1cf57e1$var$uint8Tag:
        case $d39f2b91b1cf57e1$var$uint8ClampedTag:
        case $d39f2b91b1cf57e1$var$uint16Tag:
        case $d39f2b91b1cf57e1$var$uint32Tag:
            return $3ltG5(object, isDeep);
        case $d39f2b91b1cf57e1$var$mapTag:
            return new Ctor;
        case $d39f2b91b1cf57e1$var$numberTag:
        case $d39f2b91b1cf57e1$var$stringTag:
            return new Ctor(object);
        case $d39f2b91b1cf57e1$var$regexpTag:
            return $1JTkQ(object);
        case $d39f2b91b1cf57e1$var$setTag:
            return new Ctor;
        case $d39f2b91b1cf57e1$var$symbolTag:
            return $daLgt(object);
    }
}
module.exports = $d39f2b91b1cf57e1$var$initCloneByTag;

});
parcelRegister("cdpQB", function(module, exports) {

var $8LtMv = parcelRequire("8LtMv");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $8e4abfb75db4db5f$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $8LtMv(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $8e4abfb75db4db5f$var$cloneDataView;

});

parcelRegister("1JTkQ", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $1444ead8887bea9a$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $1444ead8887bea9a$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $1444ead8887bea9a$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $1444ead8887bea9a$var$cloneRegExp;

});

parcelRegister("daLgt", function(module, exports) {

var $eH1Sa = parcelRequire("eH1Sa");
/** Used to convert symbols to primitives and strings. */ var $9970df4e64e669aa$var$symbolProto = $eH1Sa ? $eH1Sa.prototype : undefined, $9970df4e64e669aa$var$symbolValueOf = $9970df4e64e669aa$var$symbolProto ? $9970df4e64e669aa$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9970df4e64e669aa$var$cloneSymbol(symbol) {
    return $9970df4e64e669aa$var$symbolValueOf ? Object($9970df4e64e669aa$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $9970df4e64e669aa$var$cloneSymbol;

});


parcelRegister("kEj1q", function(module, exports) {

var $6lRLO = parcelRequire("6lRLO");

var $dN01R = parcelRequire("dN01R");

var $hF8du = parcelRequire("hF8du");
/* Node.js helper references. */ var $f0864c74f9aa056a$var$nodeIsMap = $hF8du && $hF8du.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $f0864c74f9aa056a$var$isMap = $f0864c74f9aa056a$var$nodeIsMap ? $dN01R($f0864c74f9aa056a$var$nodeIsMap) : $6lRLO;
module.exports = $f0864c74f9aa056a$var$isMap;

});
parcelRegister("6lRLO", function(module, exports) {

var $iPK9x = parcelRequire("iPK9x");

var $gST7B = parcelRequire("gST7B");
/** `Object#toString` result references. */ var $49fe69dffee4a1f0$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $49fe69dffee4a1f0$var$baseIsMap(value) {
    return $gST7B(value) && $iPK9x(value) == $49fe69dffee4a1f0$var$mapTag;
}
module.exports = $49fe69dffee4a1f0$var$baseIsMap;

});


parcelRegister("6ERIi", function(module, exports) {

var $9B9zW = parcelRequire("9B9zW");

var $dN01R = parcelRequire("dN01R");

var $hF8du = parcelRequire("hF8du");
/* Node.js helper references. */ var $4d9024e45e2ef7eb$var$nodeIsSet = $hF8du && $hF8du.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $4d9024e45e2ef7eb$var$isSet = $4d9024e45e2ef7eb$var$nodeIsSet ? $dN01R($4d9024e45e2ef7eb$var$nodeIsSet) : $9B9zW;
module.exports = $4d9024e45e2ef7eb$var$isSet;

});
parcelRegister("9B9zW", function(module, exports) {

var $iPK9x = parcelRequire("iPK9x");

var $gST7B = parcelRequire("gST7B");
/** `Object#toString` result references. */ var $6fceffe7c3950965$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $6fceffe7c3950965$var$baseIsSet(value) {
    return $gST7B(value) && $iPK9x(value) == $6fceffe7c3950965$var$setTag;
}
module.exports = $6fceffe7c3950965$var$baseIsSet;

});




parcelRegister("hUaUz", function(module, exports) {
$parcel$export(module.exports, "getUserTiming", () => $d0902163487c995b$export$4660d4a735328f2a);
var $d0902163487c995b$var$n = "undefined" != typeof window ? window.performance : null;
function $d0902163487c995b$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $d0902163487c995b$export$abfb0136cf8e916b(),
        effectiveConnectionType: $d0902163487c995b$export$265dfeca3f5017b9(),
        timeToFirstByte: $d0902163487c995b$export$9a2904da0506c3ba(),
        firstPaint: $d0902163487c995b$export$819e7a0b13f5961(),
        firstContentfulPaint: $d0902163487c995b$export$3086fa1a9fb7f683(),
        domContentLoaded: $d0902163487c995b$export$d6856d1fab905de0(),
        onLoad: $d0902163487c995b$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $d0902163487c995b$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $d0902163487c995b$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $d0902163487c995b$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $d0902163487c995b$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $d0902163487c995b$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $d0902163487c995b$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $d0902163487c995b$export$a2a699fa5b2b1ed4(n);
    });
}
function $d0902163487c995b$export$bf7f2fce5c1cf636(e) {
    $d0902163487c995b$var$n && $d0902163487c995b$var$n.mark && $d0902163487c995b$var$n.mark(e);
}
function $d0902163487c995b$export$83602b44513dc228(e, t) {
    if ($d0902163487c995b$var$n && $d0902163487c995b$var$n.measure) try {
        $d0902163487c995b$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $d0902163487c995b$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $d0902163487c995b$export$819e7a0b13f5961() {
    if (!$d0902163487c995b$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $d0902163487c995b$export$3086fa1a9fb7f683() {
    if (!$d0902163487c995b$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $d0902163487c995b$export$9a2904da0506c3ba() {
    if (!$d0902163487c995b$var$n) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $d0902163487c995b$export$d6856d1fab905de0() {
    if (!$d0902163487c995b$var$n) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $d0902163487c995b$export$7259a7b98f0280a3() {
    if (!$d0902163487c995b$var$n) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $d0902163487c995b$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $d0902163487c995b$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $d0902163487c995b$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $d0902163487c995b$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $d0902163487c995b$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $d0902163487c995b$export$4660d4a735328f2a() {
    if (!$d0902163487c995b$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $d0902163487c995b$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $d0902163487c995b$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $d0902163487c995b$export$a0d4d2a74c7df9f() {
    return $d0902163487c995b$var$n && "undefined" != typeof PerformanceResourceTiming ? $d0902163487c995b$var$n.getEntriesByType("navigation").concat($d0902163487c995b$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $d0902163487c995b$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}

});

const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

const $790d54a7af2f6d42$export$d8b468db8a225bc9 = 250;

const $9f5054f87e3e2d3a$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9f5054f87e3e2d3a$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';

const $8ce4c0417f34b437$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $15a246887205f3f6$export$93809551debf385f = '0.1.7';

const $1d063e541d94c81b$export$b98e411ae80c806f = '/';

/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $3a071bccf8601cb8$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


$parcel$global.rlb("aZ0ZH")
//# sourceMappingURL=shared~commons~stable~ar.d2bd2dd4.js.map
